import {
  Form,
  Input,
  InputNumber,
  Button,
  Tabs,
  Radio,
  Select,
  Card,
  DatePicker,
  Upload,
  notification,
  message,
  Row,
  Col,
  Modal,
  Divider,
  Typography,
  Table,
  Space,
  Tag,
  Tooltip,
  Image,
  Alert,
  Collapse,
  Checkbox,
  Popover,
  Breadcrumb,
} from "antd";
import {
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
  CheckCircleFilled,
  InfoCircleOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  UpOutlined,
  DownOutlined,
  AlertFilled,
  WarningFilled,
  ArrowDownOutlined,
  ArrowUpOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import moment from "moment";

import "./styles.css";
import { Context } from "../../context";
import { Delete, Fetch, Post, Put } from "../../fetch";
import { convertIdToKey, countryCodes, currencycodes } from "../../utils";
import MultiCurrencyInput from "../MultiCurrencyInput/index";
import UploadVideo from "../UploadContent/videos";
import UploadTrailer from "../UploadContent/trailers";
import UploadSubtitles from "../UploadContent/subtitles";
import Column from "antd/lib/table/Column";
import AddEpisode from "./AddEpisode";

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;
const { confirm } = Modal;
const { Panel } = Collapse;

const AddContent = ({ updateTab }) => {
  const [activeTab, setActiveTab] = useState("1");
  const [activeKey, setActiveKey] = useState("1");
  const [contentKey, setContentKey] = useState("1");
  const [refresh, setRefresh] = useState(false);
  const [refreshMovies, setRefreshMovies] = useState(false);
  const [refreshSeries, setRefreshSeries] = useState(false);
  const [contentType, setContentType] = useState("movie");
  const [availability, setAvailability] = useState("perpetual");
  const [monetizationModel, setMonetizationModel] = useState("");
  const [modelType, setModelType] = useState("default");
  const [movies, setMovies] = useState([]);
  const [series, setSeries] = useState([]);
  const [albums, setAlbums] = useState([]);
  const [saved, setSaved] = useState(false);
  const [maturityTpe, setMaturityType] = useState("CBFC");
  const [count, setCount] = useState(0);
  const [activeObj, setActiveObj] = useState({});
  const [listType, setListType] = useState("allow_all");
  const [showModal, setShowModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showTable, setShowTable] = useState(true);
  const [showTitle, setShowTitle] = useState(false);
  const [filter, setFilter] = useState("all");
  const [Telugu, setTelugu] = useState(false);
  const [Hindi, setHindi] = useState(false);
  const [Tamil, setTamil] = useState(false);
  const [title, setTitle] = useState(false);
  const [ratingType, setRatingType] = useState("CBFC");
  const [id, setId] = useState("");
  const [role, setRole] = useState("");
  const [upload, setUpload] = useState({
    id: null,
    season: null,
    episode: null,
    type: "",
  });

  const codes = ["INR", "BDT", "GBP", "NPR", "MUR", "SGD", "AED", "EUR", "USD"];

  const [seriesId, setSeriesId] = useState();
  const [movie, setMovie] = useState();
  const [deleteEpisode, setDeleteEpisode] = useState({});
  const allowList = [];
  let del_list = [];
  const [dateString, setDateString] = useState(null);

  const { token, apiUrl, superAdmin } = useContext(Context);

  const [contentInfoForm] = Form.useForm();
  const [seriesContentInfoForm] = Form.useForm();

  const [castCrewAvailabilityForm] = Form.useForm();
  const [seriesCastCrewAvailabilityForm] = Form.useForm();

  const [episodesForm] = Form.useForm();

  const [posterBannersForm] = Form.useForm();
  const [geoAccessForm] = Form.useForm();
  const [monetizationStreamingForm] = Form.useForm();
  const [standAloneForm] = Form.useForm();
  const [titleForm] = Form.useForm();

  const [actors, setActors] = useState([]);
  const [directors, setDirectors] = useState([]);
  const [producers, setProducers] = useState([]);
  const [singers, setSingers] = useState([]);
  const [lyricists, setLyricists] = useState([]);
  const [genres, setGenres] = useState([]);
  const [languages, setLanguages] = useState([]);

  const [cardImageLoading, setCardImageLoading] = useState(false);
  const [detailImageLoading, setDetailImageLoading] = useState(false);
  const [trailerImageLoading, setTrailerImageLoading] = useState(false);
  const [cardImageUrl, setCardImageUrl] = useState();
  const [detailImageUrl, setDetailImageUrl] = useState();
  const [trailerImageUrl, setTrailerImageUrl] = useState();
  const [addStandaloneContent, setAddStandaloneContent] = useState(false);
  const [addSeriesContent, setAddSeriesContent] = useState(false);
  const [seriesTitleModal, setSeriesTitleModal] = useState(false);
  const [selectionType, setSelectionType] = useState("checkbox");

  const { Text, Link, Title } = Typography;

  const [addStandloneTitleForm] = Form.useForm();
  const [addSeriesTitleForm] = Form.useForm();

  const ratings = [
    {
      type: "CBFC — Central Board of Film Certification",
      value: "CBFC",
    },
    {
      type: "BR Official Rating",
      value: "BR",
    },
  ];

  let ratingValues =
    ratingType === "CBFC"
      ? [
          {
            key: "U",
            value: "U",
          },
          {
            key: "U/A",
            value: "U/A",
          },
          {
            key: "A",
            value: "A",
          },
          {
            key: "S",
            value: "S",
          },
        ]
      : ratingType === "BR"
      ? [
          {
            key: "L",
            value: "L",
          },
          {
            key: "10",
            value: "10",
          },
          {
            key: "12",
            value: "12",
          },
          {
            key: "14",
            value: "14",
          },
          {
            key: "16",
            value: "16",
          },
          {
            key: "18",
            value: "18",
          },
        ]
      : [];

  const availableTableData = [
    {
      key: "1",
      location: "United States",
      buy: "ASAP",
      rent: "ASAP",
    },
    {
      key: "2",
      location: "United Kingdom",
      buy: "ASAP",
      rent: "ASAP",
    },
  ];

  const availableTableColummns = [
    {
      title: "Locations (indicative availability)",
      dataIndex: "location",
      key: "location",
      /* return: (_, data) => (
        <>
          <Text style={{ width: '100%' }}>
            <strong>{_.title.location}</strong>
          </Text>
          <Text color="secondary" style={{ width: '100%', fontSize: '13px' }}>
            <strong>{data.title.sub}</strong>
          </Text>
        </>
      ), */
    },
    {
      title: "Subscription (TVOD)",
      dataIndex: "buy",
      key: "buy",
    },
    {
      title: "Rent (TVOD)",
      dataIndex: "rent",
      key: "rent",
    },
  ];

  //  Episodes Sorting Buttons
  const episodesSortingButtons = () => {
    return (
      <>
        <Button style={{ marginRight: "10px" }}>
          <ArrowDownOutlined />
        </Button>
        <Button>
          <ArrowUpOutlined />
        </Button>
      </>
    );
  };

  //  addLanguage Popover
  const addLanguagePopover = () => {
    return (
      <Row>
        <Col span="24">
          <Checkbox
            onChange={(e) => setTelugu(e.target.checked)}
            checked={Telugu}
          >
            Telugu
          </Checkbox>
          <br />
          <Checkbox
            onChange={(e) => setHindi(e.target.checked)}
            checked={Hindi}
          >
            Hindi
          </Checkbox>
          <br />
          <Checkbox
            onChange={(e) => setTamil(e.target.checked)}
            checked={Tamil}
          >
            Tamil
          </Checkbox>
        </Col>
      </Row>
    );
  };

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    getCheckboxProps: (record) => ({
      // Column configuration not to be checked
      name: record.buy,
    }),
  };

  useEffect(() => {
    setCount(contentKey);

    return () => {
      setAddStandaloneContent(false);
    };
  }, [contentKey, contentType, activeTab]);

  const cardImageUploadButton =
    contentType === "movie" || contentType === "song" ? (
      <div>
        {cardImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload (300x400)</div>
      </div>
    ) : (
      <div>
        {cardImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload (450x250)</div>
      </div>
    );

  const detailImageUploadButton = (
    <div>
      {detailImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload (1500x500)</div>
    </div>
  );

  const trailerImageUploadButton = (
    <div>
      {trailerImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload (512x288)</div>
    </div>
  );

  const beforeImageUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("Only JPG and PNG files are allowed");
    }
    const isLt2M = file.size / 1024 / 1024 < 1;
    if (!isLt2M) {
      message.error("Image must be smaller than 1M");
    }

    return isJpgOrPng && isLt2M;
  };

  const handleCardImageUploadStatusChange = (info) => {
    if (info.file.status === "uploading") {
      setCardImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      setCardImageLoading(false);
      setCardImageUrl(info.file.response.url + "/desktopCard");
      posterBannersForm.setFieldsValue({ cardImage: info.file.response.url });
    }
  };

  const handleDetailImageUploadStatusChange = (info) => {
    if (info.file.status === "uploading") {
      setDetailImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      setDetailImageLoading(false);
      setDetailImageUrl(info.file.response.url + "/desktopDetail");
      posterBannersForm.setFieldsValue({ detailImage: info.file.response.url });
    }
  };

  const handleTrailerImageUploadStatusChange = (info) => {
    if (info.file.status === "uploading") {
      setTrailerImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      setTrailerImageLoading(false);
      setTrailerImageUrl(info.file.response.url + "desktopTrailer");
      posterBannersForm.setFieldsValue({
        trailerImage: info.file.response.url,
      });
    }
  };

  useEffect(() => {
    Fetch(`${apiUrl}/movies`, token, (result) => {
      let movies = convertIdToKey(result.movies);
      let m = [];
      movies.forEach((movie) => {
        if (!movie.availability) movie.availability = "unpublished";
        if (filter === "draft" && movie.availability === "unpublished") {
          m.push(movie);
        } else if (
          filter === "published" &&
          movie.availability === "perpetual"
        ) {
          m.push(movie);
        }
        if (filter === "all") {
          m.push(movie);
        }
      });
      setMovies(m);
      setRefreshMovies(false);
    });

    Fetch(`${apiUrl}/series`, token, (result) => {
      let series = convertIdToKey(result.series);
      let m = [];
      series.forEach((s) => {
        if (!s.availability) s.availability = "unpublished";
        if (filter === "draft" && s.availability === "unpublished") {
          m.push(s);
        } else if (filter === "published" && s.availability === "perpetual") {
          m.push(s);
        }
        if (filter === "all") {
          m.push(s);
        }
      });
      setSeries(m);
      setRefreshSeries(false);
    });

    Fetch(`${apiUrl}/artists`, token, (result) => {
      setActors(result.artists);
    });

    Fetch(`${apiUrl}/mediaHouses`, token, (result) => {
      setDirectors(result.directors);
      setProducers(result.producers);
      setSingers(result.singers);
      setLyricists(result.lyricists);
    });

    Fetch(`${apiUrl}/genres`, token, (result) => {
      setGenres(result.genres);
    });

    Fetch(`${apiUrl}/languages`, token, (result) => {
      setLanguages(result.languages);
    });

    Fetch(`${apiUrl}/songs`, token, (result) => {
      const albums = convertIdToKey(result.songs);
      setAlbums(albums);
    });
  }, [apiUrl, token, filter, refreshMovies, refreshSeries]);

  // const onFinish = async (e) => {
  //   e.preventDefault();

  //   let contentInfo, castCrewAvailability, posterBanners, monetizationStreaming;
  //   let valid = true;

  //   try {
  //     contentInfo = await contentInfoForm.validateFields();
  //   } catch (err) {
  //     console.error(err);
  //     notification.error({
  //       message: 'Content Info Error',
  //       description: 'Required fields are incorrect/missing',
  //     });
  //     valid = false;
  //   }

  //   try {
  //     castCrewAvailability = await castCrewAvailabilityForm.validateFields();
  //     console.log(castCrewAvailability);
  //   } catch (err) {
  //     console.error(err);
  //     notification.error({
  //       message: 'Cast & Crew Error',
  //       description: 'Required fields are incorrect/missing',
  //     });
  //     valid = false;
  //   }

  //   try {
  //     posterBanners = await posterBannersForm.validateFields();
  //   } catch (err) {
  //     console.error(err);
  //     notification.error({
  //       message: 'Posters & Banner Error',
  //       description: 'Required fields are incorrect/missing',
  //     });
  //     valid = false;
  //   }

  //   try {
  //     monetizationStreaming = await monetizationStreamingForm.validateFields();
  //     if (monetizationStreaming.startDate)
  //       monetizationStreaming['startDate'] =
  //         monetizationStreaming.startDate.toISOString(true);
  //     if (monetizationStreaming.endDate)
  //       monetizationStreaming['endDate'] =
  //         monetizationStreaming.endDate.toISOString(true);
  //   } catch (err) {
  //     console.log(err);
  //     notification.error({
  //       message: 'Monetization & Stream Error',
  //       description: 'Required fields are incorrect/missing',
  //     });
  //     valid = false;
  //   }

  //   if (valid && contentType === 'movie') {
  //     Post(
  //       `${apiUrl}/movies`,
  //       token,
  //       {
  //         ...contentInfo,
  //         ...castCrewAvailability,
  //         ...posterBanners,
  //         ...monetizationStreaming,
  //       },
  //       (result) => {
  //         if (result.success) {
  //           contentInfoForm.resetFields();
  //           castCrewAvailabilityForm.resetFields();
  //           posterBannersForm.resetFields();
  //           monetizationStreamingForm.resetFields();
  //           setCardImageUrl('');
  //           setDetailImageUrl('');
  //           setActiveTab('1');

  //           notification.success({
  //             message: 'Success',
  //             description: 'Content created',
  //           });
  //         }
  //       },
  //       () => {
  //         notification.error({
  //           message: 'Error',
  //           description: 'Please check console for more details',
  //         });
  //       }
  //     );
  //   } else if (valid && contentType === 'series') {
  //     Post(
  //       `${apiUrl}/series/${contentInfo.series}/episodes`,
  //       token,
  //       {
  //         ...contentInfo,
  //         ...castCrewAvailability,
  //         ...posterBanners,
  //         ...monetizationStreaming,
  //       },
  //       (result) => {
  //         if (result.success) {
  //           contentInfoForm.resetFields();
  //           castCrewAvailabilityForm.resetFields();
  //           posterBannersForm.resetFields();
  //           monetizationStreamingForm.resetFields();
  //           setCardImageUrl('');
  //           setDetailImageUrl('');
  //           setActiveTab('1');

  //           notification.success({
  //             message: 'Success',
  //             description: 'Content created',
  //           });
  //         }
  //       },
  //       () => {
  //         notification.error({
  //           message: 'Error',
  //           description: 'Please check console for more details',
  //         });
  //       }
  //     );
  //   } else if (valid && contentType === 'song') {
  //     Post(
  //       `${apiUrl}/songs`,
  //       token,
  //       {
  //         ...contentInfo,
  //         ...castCrewAvailability,
  //         ...posterBanners,
  //         ...monetizationStreaming,
  //       },
  //       (result) => {
  //         if (result.success) {
  //           contentInfoForm.resetFields();
  //           castCrewAvailabilityForm.resetFields();
  //           posterBannersForm.resetFields();
  //           monetizationStreamingForm.resetFields();
  //           setCardImageUrl('');
  //           setDetailImageUrl('');
  //           setActiveTab('1');

  //           notification.success({
  //             message: 'Success',
  //             description: 'Content created',
  //           });
  //         }
  //       },
  //       () => {
  //         notification.error({
  //           message: 'Error',
  //           description: 'Please check console for more details',
  //         });
  //       }
  //     );
  //   }
  // };

  // const handleTabChange = async () => {
  //   let t = parseInt(contentKey) + 1;
  //   if (t >= 6) t = 1;
  //   if (saved) {
  //     setSaved(false);
  //   } else {
  //     confirm({
  //       title: 'Your changes will be lost if not Saved',
  //       icon: <ExclamationCircleOutlined />,
  //       okText: 'Save',
  //       okType: 'primary',
  //       cancelText: 'Leave',
  //       cancelType: 'danger',
  //       async onOk() {
  //         await handleSave();
  //         setSaved(false);
  //         setContentKey(`${t}`);
  //         notification.success({
  //           message: 'Saved successfully',
  //         });
  //       },
  //       onCancel() {
  //         console.log('cancelled save');
  //         setContentKey(contentKey);
  //       },
  //     });
  //   }
  // };

  // const handleSave = async () => {
  //   let values = await standAloneForm.validateFields();
  //   await setId(sessionStorage.getItem('content_id').toString());
  //   console.log(id);
  //   if (contentType === 'movie' && activeTab === '1') {
  //     await Put(
  //       `${apiUrl}/movies/${sessionStorage.getItem('content_id')}`,
  //       token,
  //       { ...values },
  //       (result) => {
  //         if (result.success) {
  //           console.log('Movie Updated');
  //           setSaved(true);
  //           let t = parseInt(contentKey) + 1;
  //           if (t >= 6) t = 1;
  //           setContentKey(`${t}`);
  //         }
  //       }
  //     );
  //   } else if (contentType === 'song' && activeTab == '1') {
  //     await Put(
  //       `${apiUrl}/songs/${sessionStorage.getItem('content_id')}`,
  //       token,
  //       { ...values },
  //       (result) => {
  //         if (result.success) {
  //           console.log('Song Updated');
  //           setSaved(true);
  //           let t = parseInt(contentKey) + 1;
  //           if (t >= 6) t = 1;
  //           setContentKey(`${t}`);
  //         }
  //       }
  //     );
  //   } else {
  //     await Put(
  //       `${apiUrl}/series/${sessionStorage.getItem('content_id')}`,
  //       token,
  //       { ...values },
  //       (result) => {
  //         if (result.success) {
  //           console.log('Series Updated');
  //           setSaved(true);
  //           let t = parseInt(contentKey) + 1;
  //           if (t >= 6) t = 1;
  //           setContentKey(`${t}`);
  //         }
  //       }
  //     );
  //   }
  // };

  const handleContentInfoSubmit = async () => {
    let contentInfo = await contentInfoForm.validateFields();
    console.log("content info form values  - ", contentInfo);
    let valid = true;
    try {
      contentInfo = await contentInfoForm.validateFields();
      if (contentInfo.releaseDate) {
        contentInfo.releaseDate = contentInfo.releaseDate.toISOString();
      }
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Content Info Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
    }
    if (contentType === "movie") {
      let movieId = sessionStorage.getItem("content_id");
      Put(
        `${apiUrl}/movies/${movieId}`,
        token,
        { ...contentInfo },
        (result) => {
          if (result.success) {
            notification.success({
              message: "Success",
              description: "Movie Saved",
            });
            setActiveKey("2");
          }
        }
      );
    }
    console.log(seriesId);
    if (contentType === "series" && seriesId) {
      // console.log('series id before api call - ', seriesId)
      Post(
        `${apiUrl}/series/${seriesId}/episodes`,
        token,
        { ...contentInfo },
        (result) => {
          console.log(result);
          if (result.success) {
            sessionStorage.setItem("content_id", seriesId);
            console.log(sessionStorage.getItem("content_id"));
            notification.success({
              message: "Success",
              description: "Episode Saved",
            });
            // console.log(contentInfo)
            sessionStorage.setItem("episode_data", JSON.stringify(contentInfo));
            console.log(
              "episode data after updating - ",
              JSON.parse(sessionStorage.getItem("episode_data"))
            );
          }
        }
      );
    }
    if (contentType === "song") {
      Post(`${apiUrl}/songs`, token, { ...contentInfo }, (result) => {
        if (result.success) {
          console.log("song id - ", result.success);
          sessionStorage.setItem("content_id", result.success);
          notification.success({
            message: "Success",
            description: "Song Saved",
          });
        }
      });
    }
  };

  const handleSeriesContentInfoSubmit = async () => {
    let contentInfo = await seriesContentInfoForm.validateFields();
    let valid = true;
    try {
      contentInfo = await seriesContentInfoForm.validateFields();
      if (contentInfo.releaseDate) {
        contentInfo.releaseDate = contentInfo.releaseDate.toISOString();
      }
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Content Info Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
    }
    let id = sessionStorage.getItem("content_id");
    if (id) {
      Put(`${apiUrl}/series/${id}`, token, { ...contentInfo }, (result) => {
        console.log(result);
        if (result.success) {
          notification.success({
            message: "Success",
            description: "Episode Saved",
          });
          setActiveKey("2");
        }
      });
    }
  };

  const handleCastCrewSubmit = async () => {
    let castCrewAvailability;
    let valid = false;
    try {
      castCrewAvailability = await castCrewAvailabilityForm.validateFields();
      console.log(castCrewAvailability);
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Cast & Crew Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
    }
    let id = sessionStorage.getItem("content_id");
    if (id) {
      console.log("content_id - ", id);
      if (contentType === "movie") {
        Put(
          `${apiUrl}/movies/${id}`,
          token,
          { ...castCrewAvailability },
          (result) => {
            if (result.success) {
              notification.success({
                message: "Success",
                description: "Movie Saved",
              });
            }
          }
        );
      }
      if (contentType === "series" && seriesId) {
        try {
          const castCrewAvailability =
            await castCrewAvailabilityForm.validateFields();
          let episode = JSON.parse(sessionStorage.getItem("episode_data"));
          // console.log('episode data before updating cast crew - ', episode)
          let newEpisode = { ...episode, ...castCrewAvailability };
          Post(
            `${apiUrl}/series/${seriesId}/episodes`,
            token,
            {
              ...newEpisode,
              old: { ...episode },
            },
            (result) => {
              if (result.success) {
                notification.success({
                  message: "Success",
                  description: "Epsiode edited",
                });
                sessionStorage.setItem(
                  "episode_data",
                  JSON.stringify(newEpisode)
                );
                // console.log("episode data after cast and Crew - ", JSON.parse(sessionStorage.getItem('episode_data')))
              }
            },
            () => {
              notification.error({
                message: "Error",
                description: "Please check console for more details",
              });
            }
          );
        } catch (err) {
          console.error(err);
          notification.error({
            message: "Error",
            description: "Required fields incorrect/missing",
          });
        }
      }
      if (contentType === "song") {
        Put(
          `${apiUrl}/songs/${id}`,
          token,
          { ...castCrewAvailability },
          (result) => {
            if (result.success) {
              notification.success({
                message: "Success",
                description: "Song Saved",
              });
            }
          }
        );
      }
    }
  };

  const handleSeriesCastCrewSubmit = async () => {
    let castCrewAvailability;
    let valid = false;
    try {
      castCrewAvailability =
        await seriesCastCrewAvailabilityForm.validateFields();
      console.log(castCrewAvailability);
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Cast & Crew Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
    }
    let id = sessionStorage.getItem("content_id");
    if (id) {
      console.log("content_id - ", id);
      try {
        Put(
          `${apiUrl}/series/${id}`,
          token,
          {
            ...castCrewAvailability,
          },
          (result) => {
            if (result.success) {
              notification.success({
                message: "Success",
                description: "Series Saved",
              });
              setActiveKey("3");
            }
          },
          () => {
            notification.error({
              message: "Error",
              description: "Please check console for more details",
            });
          }
        );
      } catch (err) {
        console.error(err);
        notification.error({
          message: "Error",
          description: "Required fields incorrect/missing",
        });
      }
    }
  };

  const handleDeleteEpisode = async (key, checked) => {
    // console.log('epsode number - ', key);
    // console.log('should delete - ', checked);
    del_list.push({ key: key, delete: checked });
  };

  const handleEpisodeSubmit = async () => {
    const episodes = await episodesForm.validateFields();
    console.log("episodes data - ", episodes.episodes);
    console.log("del_list - ", del_list);
    let ep_data = episodes.episodes;
    let values = [];
    console.log(ep_data);
    ep_data.forEach((ep) => {
      console.log("ep data ", ep);
      if (del_list.length > 0) {
        console.log("del_list is not empty");
        for (let i in del_list) {
          if (
            del_list[i].key === ep["episode#"] &&
            del_list[i].delete === true
          ) {
            console.log("ep delete - ", ep);
          } else {
            console.log("condition for delete failed");
            values.push(ep);
          }
        }
      } else {
        values = ep_data;
      }
    });
    console.log("being posted - ", values);
    let id = sessionStorage.getItem("content_id");
    if (id) {
      Put(`${apiUrl}/series/${id}`, token, { episodes: values }, (result) => {
        if (result.success) {
          notification.success({
            message: "Success",
            description: "Episodes Updated",
          });
          setActiveKey("1");
          del_list = [];
          setRefresh(true);
        }
      });
    }
  };

  useEffect(() => {
    console.log("refresh is now - ", refresh);
    if (refresh) {
      let id = sessionStorage.getItem("content_id");
      let data = { key: id };
      handleFetchSeries(data);
      setActiveTab("2");
      setActiveKey("3");
      setRefresh(false);
      console.log("the series id is - ", id);
    }
  }, [refresh]);

  const handleAvailabilitySubmit = async () => {
    let geoAccess;
    let valid = true;
    try {
      geoAccess = await geoAccessForm.validateFields();
      if (listType === "allow") {
        for (const i in countryCodes) {
          if (geoAccess.countryMap.includes(i)) allowList.push(i);
        }
        console.log(allowList);
      }
      if (listType === "disallow") {
        for (const i in countryCodes) {
          if (!geoAccess.countryMap.includes(i)) allowList.push(i);
        }
        console.log(allowList);
      }
      if (listType === "allow_all") {
        for (const i in countryCodes) {
          allowList.push(i);
        }
      }
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Geo Access Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
    }
    let id = sessionStorage.getItem("content_id");
    if (id) {
      console.log("content_id - ", id);
      if (contentType === "movie") {
        Put(
          `${apiUrl}/movies/${id}`,
          token,
          {
            allowedCountries: allowList,
            listType: listType,
          },
          (result) => {
            if (result.success) {
              notification.success({
                message: "Success",
                description: "Movie Saved",
              });
            }
          }
        );
      }
    }
  };

  const handleSeriesAvailabilitySubmit = async () => {
    let geoAccess;
    let valid = true;
    try {
      geoAccess = await geoAccessForm.validateFields();
      if (listType === "allow") {
        for (const i in countryCodes) {
          if (geoAccess.countryMap.includes(i)) allowList.push(i);
        }
        console.log(allowList);
      }
      if (listType === "disallow") {
        for (const i in countryCodes) {
          if (!geoAccess.countryMap.includes(i)) allowList.push(i);
        }
        console.log(allowList);
      }
      if (listType === "allow_all") {
        for (const i in countryCodes) {
          allowList.push(i);
        }
      }
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Geo Access Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
    }
    let id = sessionStorage.getItem("content_id");
    if (id) {
      console.log("content_id - ", id);
      Put(
        `${apiUrl}/series/${id}`,
        token,
        {
          allowedCountries: allowList,
          listType: listType,
        },
        (result) => {
          if (result.success) {
            notification.success({
              message: "Success",
              description: "Series Saved",
            });
          }
        }
      );
    }
  };

  // const handlePosterBannersSubmit = async () => {
  //   let posterBanners
  //   let valid = true
  //   try {
  //     posterBanners = await posterBannersForm.validateFields();
  //   } catch (err) {
  //     console.error(err);
  //     notification.error({
  //       message: "Posters & Banner Error",
  //       description: "Required fields are incorrect/missing",
  //     });
  //     valid = false;
  //   }
  //   let id = sessionStorage.getItem('content_id')
  //   if (id) {
  //     console.log('content_id - ', id)

  //     if (contentType === 'movie') {
  //       Put(
  //         `${apiUrl}/movies/${id}`, token, { ...posterBanners }, (result) => {
  //           if (result.success) {
  //             notification.success({
  //               message: 'Success',
  //               description: 'Movie Saved'
  //             })
  //           }
  //         }
  //       )

  //     }
  //     if (contentType === 'series' && seriesId) {
  //       try {
  //         const posterBanners = await posterBannersForm.validateFields();
  //         let episode = JSON.parse(sessionStorage.getItem('episode_data'))
  //         // console.log('episode data before updating cast crew - ', episode)
  //         let newEpisode = { ...episode, ...posterBanners }
  //         Post(
  //           `${apiUrl}/series/${seriesId}/episodes`,
  //           token,
  //           {
  //             ...newEpisode,
  //             old: { ...episode },
  //           },
  //           (result) => {
  //             if (result.success) {
  //               notification.success({
  //                 message: "Success",
  //                 description: "Epsiode edited",
  //               });
  //               sessionStorage.setItem('episode_data', JSON.stringify(newEpisode))
  //               // console.log("episode data after cast and Crew - ", JSON.parse(sessionStorage.getItem('episode_data')))
  //             }
  //           },
  //           () => {
  //             notification.error({
  //               message: "Error",
  //               description: "Please check console for more details",
  //             });
  //           }
  //         );
  //       } catch (err) {
  //         console.error(err);
  //         notification.error({
  //           message: "Error",
  //           description: "Required fields incorrect/missing",
  //         });
  //       }
  //     }
  //     if (contentType === 'song') {
  //       Put(
  //         `${apiUrl}/songs/${id}`, token, { ...posterBanners }, (result) => {
  //           if (result.success) {
  //             notification.success({
  //               message: 'Success',
  //               description: 'Song Saved'
  //             })
  //           }
  //         }
  //       )
  //     }
  //   }

  // }

  // const handleGeoAccessSubmit = async () => {
  //   let geoAccess
  //   let valid = true
  //   try {
  //     geoAccess = await geoAccessForm.validateFields();
  //     if (listType === 'allow') {
  //       for (const i in countryCodes) {
  //         if (geoAccess.countryMap.includes(i)) allowList.push(i)
  //       }
  //       console.log(allowList)
  //     }
  //     if (listType === 'disallow') {
  //       for (const i in countryCodes) {
  //         if (!geoAccess.countryMap.includes(i)) allowList.push(i)
  //       }
  //       console.log(allowList)
  //     }
  //     if (listType === 'allow_all') {
  //       for (const i in countryCodes) {
  //         allowList.push(i)
  //       }
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     notification.error({
  //       message: "Geo Access Error",
  //       description: "Required fields are incorrect/missing",
  //     });
  //     valid = false;
  //   }
  //   let id = sessionStorage.getItem('content_id')
  //   if (id) {
  //     console.log('content_id - ', id)
  //     if (contentType === 'movie') {
  //       Put(
  //         `${apiUrl}/movies/${id}`, token,
  //         {
  //           allowedCountries: allowList,
  //           listType: listType
  //         },
  //         (result) => {
  //           if (result.success) {
  //             notification.success({
  //               message: 'Success',
  //               description: 'Movie Saved'
  //             })
  //           }
  //         }
  //       )

  //     }

  //     if (contentType === 'song') {
  //       Put(
  //         `${apiUrl}/songs/${id}`, token,
  //         {
  //           allowedCountries: allowList,
  //           listType: listType
  //         },
  //         (result) => {
  //           if (result.success) {
  //             notification.success({
  //               message: 'Success',
  //               description: 'Song Saved'
  //             })
  //           }
  //         }
  //       )
  //     }
  //   }

  // }

  const handleFetchMovie = (record) => {
    console.log(record);
    Fetch(`${apiUrl}/movies/${record.key}`, token, (result) => {
      if (result) {
        setMovie(result);
        if (result.teluguTitle || result.teluguDescription) setTelugu(true);
        if (result.hindiTitle || result.hindiDescription) setHindi(true);
        if (result.tamilTitle || result.tamilDescription) setTamil(true);
        sessionStorage.setItem("content_id", record.key);
        setShowTable(false);
        setAddStandaloneContent(true);
        contentInfoForm.setFieldsValue(result);
        castCrewAvailabilityForm.setFieldsValue(result);
        let values = result.allowedCountries;
        if (result.listType) {
          setListType(result.listType);
          geoAccessForm.setFieldValue("listType", result.listType);
        } else {
          setListType("allow_all");
          geoAccessForm.setFieldValue("listType", "allow_all");
        }
        let countries = [];
        if (result.listType === "allow") {
          geoAccessForm.setFieldValue("countryMap", values);
        }
        if (result.listType === "disallow") {
          for (const i in countryCodes) {
            if (!values.includes(i)) {
              countries.push(i);
            }
          }
          geoAccessForm.setFieldValue("countryMap", countries);
          countries = [];
        }
      }
    });
  };

  const handleFetchSeries = (record) => {
    console.log(record);
    Fetch(`${apiUrl}/series/${record.key}`, token, (result) => {
      if (result) {
        if (result.teluguTitle || result.teluguDescription) setTelugu(true);
        if (result.hindiTitle || result.hindiDescription) setHindi(true);
        if (result.tamilTitle || result.tamilDescription) setTamil(true);
        setDateString(moment(result.releaseDate).format("YYYY-MM-DD"));
        setSeriesId({
          ...result,
          releaseDate: moment(result.releaseDate).format("YYYY-MM-DD"),
        });
        sessionStorage.setItem("content_id", record.key);
        setContentType("series");
        setShowTable(false);
        setAddSeriesContent(true);
        seriesContentInfoForm.setFieldsValue(result);
        seriesCastCrewAvailabilityForm.setFieldsValue(result);
        episodesForm.setFieldsValue(result);
        let values = result.allowedCountries;
        if (result.listType) {
          setListType(result.listType);
          geoAccessForm.setFieldValue("listType", result.listType);
        } else {
          setListType("allow_all");
          geoAccessForm.setFieldValue("listType", "allow_all");
        }
        let countries = [];
        if (result.listType === "allow") {
          geoAccessForm.setFieldValue("countryMap", values);
        }
        if (result.listType === "disallow") {
          for (const i in countryCodes) {
            if (!values.includes(i)) {
              countries.push(i);
            }
          }
          geoAccessForm.setFieldValue("countryMap", countries);
          countries = [];
        }
      }
    });
  };

  const handleDeleteStandaloneContent = (record) => {
    console.log("the selected content is - ", record);
    Delete(`${apiUrl}/movies/${record.key}`, token, (result) => {
      if (result.success) {
        notification.success({
          message: "Deleted",
          description: "Content Deleted Successfully",
        });
      }
      setRefreshMovies(true);
    });
  };

  const handleDeleteSeriesContent = (record) => {
    console.log("the selected content is - ", record);
    Delete(`${apiUrl}/series/${record.key}`, token, (result) => {
      if (result.success) {
        notification.success({
          message: "Deleted",
          description: "Content Deleted Succesfully",
        });
      }
      setRefreshSeries(true);
    });
  };

  const handleStandAloneTitleSubmit = async () => {
    let values = await addStandloneTitleForm.validateFields();
    console.log("standalone title form values - ", values);

    if (contentType === "movie") {
      Post(`${apiUrl}/movies/add_title`, token, { ...values }, (result) => {
        if (result.success) {
          sessionStorage.setItem("content_id", result.content_id);
          notification.success({
            message: "Success",
            description: "Title Added Successfully",
          });
          setShowModal(false);
          setAddStandaloneContent(true);
          setShowTable(false);
          setMovie(values);
          console.log(movie);
        }
      });
    }
  };

  const handleSeriesTitleSubmit = async () => {
    let values = await addSeriesTitleForm.validateFields();
    console.log("episodic title form values - ", values);

    Post(`${apiUrl}/series/add_title`, token, { ...values }, (result) => {
      if (result.success) {
        sessionStorage.setItem("content_id", result.content_id);
        notification.success({
          message: "Success",
          description: "Title Added Successfully",
        });
        setSeriesTitleModal(false);
        setAddSeriesContent(true);
        setShowTable(false);
        setSeriesId(values);
        console.log(seriesId);
      }
    });
  };

  return (
    <>
      <div className="add-content-wrapper">
        {!addStandaloneContent && !addSeriesContent ? (
          <>
            <Row
              style={{
                backgroundColor: "#fff",
                padding: "10px 20px",
                borderBottom: "1px solid #eee",
              }}
            >
              <Col>
                <Title level={4} style={{ marginBottom: 0 }}>
                  Add Content
                </Title>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Tabs
                  activeKey={activeTab}
                  onChange={async (tab) => {
                    await setActiveTab(tab);
                    setSaved(false);
                    setShowTable(true);
                    standAloneForm.resetFields();
                    titleForm.resetFields();
                    setTitle(false);
                    console.log(contentType);
                  }}
                  className="add-content-tabs addContentTabs"
                >
                  <TabPane
                    tab={
                      <>
                        <div className="tabMainTitle">Standalone</div>
                        <span className="tabSubTitle">
                          Movies, Shorts and Songs
                        </span>
                      </>
                    }
                    key="1"
                  >
                    {showTable && (
                      <>
                        <Row>
                          <Select
                            placeholder="Search Movie"
                            showSearch
                            allowClear
                            onChange={(_, record) => {
                              handleFetchMovie(record);
                            }}
                            onClear={() => setFilter("all")}
                            style={{ width: "100%", marginBottom: "15px" }}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                          >
                            {movies.map((m) => (
                              <Option key={m.key} value={m.title}>
                                {m.title}
                              </Option>
                            ))}
                          </Select>
                        </Row>
                        <Row
                          justify={"space-between"}
                          style={{ marginBottom: "25px" }}
                        >
                          <Col>
                            {!showModal && (
                              <Button
                                className="title-btn"
                                type="primary"
                                onClick={() => {
                                  /* setShowTable(false);
                          handleTitleUpdate();
                          setShowTitle(true); */
                                  setShowModal(true);
                                }}
                              >
                                Add Title
                              </Button>
                            )}
                          </Col>
                          <Col>
                            <Select
                              defaultValue="all"
                              style={{ width: 120 }}
                              allowClear
                              onChange={(value) => {
                                setFilter(value);
                                console.log(value);
                              }}
                              options={[
                                { value: "all", label: "View All" },
                                { value: "draft", label: "Draft" },
                                { value: "published", label: "Published" },
                              ]}
                            />
                          </Col>
                        </Row>

                        {/* <Table dataSource={dummyrecord} columns={columns} /> */}
                        <Table dataSource={movies}>
                          <Column
                            title="Title"
                            dataIndex="title"
                            key="title"
                            align="left"
                            width={"20%"}
                            paddingLeft={"3%"}
                            render={(_, record) => record.title}
                          />
                          <Column
                            title="Language"
                            dataIndex={"language"}
                            key="language"
                            align="center"
                            render={(languages) => (
                              <>
                                {languages &&
                                  languages.map((language) => (
                                    <Tag color="blue" key={language}>
                                      {language}
                                    </Tag>
                                  ))}
                              </>
                            )}
                          />
                          <Column
                            title="Model"
                            dataIndex={"model"}
                            align="center"
                            render={(_, record) =>
                              record.model ? record.model : "Free"
                            }
                          />
                          <Column
                            title="Status"
                            dataIndex="availability"
                            key="availability"
                            align="center"
                            render={(_, record) =>
                              record.availability
                                ? record.availability
                                : "unpublished"
                            }
                          />
                          <Column
                            title="Action"
                            render={(_, record) => (
                              <Space>
                                <Button
                                  onClick={() => {
                                    handleFetchMovie(record);
                                  }}
                                >
                                  Edit
                                </Button>
                                <Button
                                  onClick={() => {
                                    handleDeleteStandaloneContent(record);
                                  }}
                                >
                                  Delete
                                </Button>
                              </Space>
                            )}
                          ></Column>
                        </Table>
                      </>
                    )}
                  </TabPane>
                  <TabPane
                    tab={
                      <>
                        <div className="tabMainTitle">Episodes</div>
                        <span className="tabSubTitle">
                          TV Shows, Web Series
                        </span>
                      </>
                    }
                    key={2}
                  >
                    {showTable && (
                      <>
                        <Row>
                          <Select
                            placeholder="Search Series"
                            showSearch
                            allowClear
                            onChange={(_, record) => {
                              handleFetchSeries(record);
                            }}
                            onClear={() => setFilter("all")}
                            style={{
                              width: "100%",
                              marginBottom: "15px",
                            }}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                          >
                            {series.map((m) => (
                              <Option key={m.key} value={m.title}>
                                {m.title}
                              </Option>
                            ))}
                          </Select>
                        </Row>
                        <Row
                          justify={"space-between"}
                          style={{ marginBottom: "25px" }}
                        >
                          <Col>
                            {!showModal && (
                              <Button
                                className="title-btn"
                                type="primary"
                                onClick={() => {
                                  setSeriesTitleModal(true);
                                  console.log(
                                    "series title modal is - ",
                                    seriesTitleModal
                                  );
                                }}
                              >
                                Add Title
                              </Button>
                            )}
                          </Col>
                          <Col>
                            <Select
                              defaultValue="all"
                              style={{ width: 120 }}
                              allowClear
                              onChange={(value) => setFilter(value)}
                              options={[
                                { value: "all", label: "View All" },
                                { value: "draft", label: "Draft" },
                                { value: "published", label: "Published" },
                              ]}
                            />
                          </Col>
                        </Row>
                        <Table dataSource={series}>
                          <Column
                            title="Title (Season)"
                            dataIndex="title"
                            key="title"
                            align="left"
                            paddingLeft={"3%"}
                            width={"30%"}
                            render={(_, record) =>
                              record.title && record.season
                                ? `${record.title} (S${record.season})`
                                : `${record.title} (S1)`
                            }
                          />
                          <Column
                            title="Language"
                            dataIndex={"language"}
                            key="language"
                            align="center"
                            render={(languages) => (
                              <>
                                {languages &&
                                  languages.map((language) => (
                                    <Tag color="blue" key={language}>
                                      {language}
                                    </Tag>
                                  ))}
                              </>
                            )}
                          />
                          <Column
                            title="Model"
                            dataIndex={"model"}
                            align="center"
                            render={(_, record) =>
                              record.model ? record.model : "Free"
                            }
                          />
                          <Column
                            title="Status"
                            dataIndex="availability"
                            key="availability"
                            align="center"
                            render={(_, record) =>
                              record.availability
                                ? record.availability
                                : "unpublished"
                            }
                          />
                          <Column
                            title="Action"
                            render={(_, record) => (
                              <Space>
                                <Button
                                  onClick={() => {
                                    handleFetchSeries(record);
                                  }}
                                >
                                  Edit
                                </Button>
                                <Button
                                  onClick={() => {
                                    handleDeleteSeriesContent(record);
                                  }}
                                >
                                  Delete
                                </Button>
                              </Space>
                            )}
                          ></Column>
                        </Table>
                      </>
                    )}
                  </TabPane>
                </Tabs>
              </Col>
            </Row>
          </>
        ) : (
          ""
        )}
        {/* Adding detail content of Standalone */}

        {addStandaloneContent && (
          <Row>
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <Title level={3} style={{ marginBottom: "10px" }}>
                    {movie.title}
                  </Title>
                  <Text type="secondary">
                    <>
                      <Tag
                        color="blue"
                        style={{
                          borderRadius: "100px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                        }}
                      >
                        English
                      </Tag>
                      {Telugu && (
                        <Tag
                          color="blue"
                          style={{
                            borderRadius: "100px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                          }}
                        >
                          Telugu
                        </Tag>
                      )}
                      {Hindi && (
                        <Tag
                          color="blue"
                          style={{
                            borderRadius: "100px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                          }}
                        >
                          Hindi
                        </Tag>
                      )}
                      {Tamil && (
                        <Tag
                          color="blue"
                          style={{
                            borderRadius: "100px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                          }}
                        >
                          Tamil
                        </Tag>
                      )}
                    </>
                    <Popover
                      content={addLanguagePopover}
                      trigger="click"
                      placement="bottom"
                      title="Add a Language"
                    >
                      <Button
                        size="small"
                        style={{ paddingLeft: "10px", paddingRight: "10px" }}
                      >
                        Add
                      </Button>
                    </Popover>
                  </Text>
                </Col>
              </Row>
            </Col>

            <Col span={24} style={{ marginTop: "15px" }}>
              <Tabs
                activeKey={activeKey}
                className="add-content-tabs addContentTabs"
                onChange={setActiveKey}
              >
                <TabPane tab={<label>Catalog Listing</label>} key="1">
                  <Form layout="vertical" form={contentInfoForm}>
                    <Row gutter={30}>
                      <Col span={12}>
                        <Form.Item
                          name={"title"}
                          label="Title"
                          required
                          tooltip="Some information about this title displays here"
                          extra="English"
                        >
                          <Input
                            placeholder="Enter title here..."
                            value={movie.title}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name={"category"}
                          label="Category"
                          required
                          tooltip="Some information about this title displays here"
                        >
                          <Select
                            defaultValue="movie"
                            onChange={setContentType}
                            placeholder="Select a category"
                            disabled={true}
                            value={movie.category}
                          >
                            <Option value="movie">Movie</Option>
                            <Option value="song">Song</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    {Telugu && (
                      <Row gutter={30}>
                        <Col span={12}>
                          <Form.Item
                            name={"teluguTitle"}
                            label="Telugu Title"
                            required
                            tooltip="Some information about this title displays here"
                            extra="Telugu"
                          >
                            <Input
                              placeholder="Enter title here..."
                              value={movie.TeluguTitle}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    {Hindi && (
                      <Row gutter={30}>
                        <Col span={12}>
                          <Form.Item
                            name={"hindiTitle"}
                            label="Hindi Title"
                            required
                            tooltip="Some information about this title displays here"
                            extra="Hindi"
                          >
                            <Input
                              placeholder="Enter title here..."
                              value={movie.HindiTitle}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    {Tamil && (
                      <Row gutter={30}>
                        <Col span={12}>
                          <Form.Item
                            name={"tamilTitle"}
                            label="Tamil Title"
                            required
                            tooltip="Some information about this title displays here"
                            extra="Tamil"
                          >
                            <Input
                              placeholder="Enter title here..."
                              value={movie.TamilTitle}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    <Divider style={{ marginTop: 0 }} />
                    <Row gutter={30}>
                      <Col span={24}>
                        <Form.Item
                          name={"description"}
                          dataIndex={"description"}
                          label="Synopsis"
                          required
                          tooltip="Some information about this title displays here"
                        >
                          <TextArea
                            rows={4}
                            placeholder="Enter short description of the movie"
                            showCount
                            maxLength={100}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    {Telugu && (
                      <Row gutter={30}>
                        <Col span={24}>
                          <Form.Item
                            name={"teluguDescription"}
                            dataIndex={"germanDescription"}
                            label="Synopsis (Telugu)"
                            required
                            tooltip="Some information about this title displays here"
                          >
                            <TextArea
                              rows={4}
                              placeholder="Enter short description of the movie"
                              showCount
                              maxLength={100}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    {Hindi && (
                      <Row gutter={30}>
                        <Col span={24}>
                          <Form.Item
                            name={"hindiDescription"}
                            dataIndex={"HindiDescription"}
                            label="Synopsis (Hindi)"
                            required
                            tooltip="Some information about this title displays here"
                          >
                            <TextArea
                              rows={4}
                              placeholder="Enter short description of the movie"
                              showCount
                              maxLength={100}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    {Tamil && (
                      <Row gutter={30}>
                        <Col span={24}>
                          <Form.Item
                            name={"tamilDescription"}
                            dataIndex={"TamilDescription"}
                            label="Synopsis (Tamil)"
                            required
                            tooltip="Some information about this title displays here"
                          >
                            <TextArea
                              rows={4}
                              placeholder="Enter short description of the movie"
                              showCount
                              maxLength={100}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    <Row gutter={30}>
                      <Col span={24}>
                        <Form.Item
                          name={"genre"}
                          dataIndex={"genre"}
                          label="Genre"
                          required
                          tooltip="Some information about this title displays here"
                          extra="2 genres remaining"
                        >
                          <Select
                            mode="multiple"
                            placeholder="Select a genre"
                            showSearch
                          >
                            {genres &&
                              genres.map((genre) => (
                                <Option value={genre.name}>{genre.name}</Option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={30}>
                      <Col span={24}>
                        <Form.Item
                          name={"originCountry"}
                          dataIndex={"originCountry"}
                          label="Country/Region of origin"
                          required
                          tooltip="Some information about this title displays here"
                          extra="The order of countries/regions is important, with the first entry corresponding to the production company with the greatest contribution to the title."
                        >
                          <Select placeholder={"Select a country"} showSearch>
                            {Object.entries(countryCodes).map(
                              ([code, name]) => (
                                <Option key={code} value={code}>
                                  {name}
                                </Option>
                              )
                            )}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={30}>
                      <Col span={12}>
                        <Form.Item
                          name={"language"}
                          label="Original language (Optional)"
                          tooltip="Some information about this title displays here"
                        >
                          <Select
                            placeholder="Select a language"
                            mode="multiple"
                            showSearch
                          >
                            {languages &&
                              languages.map((language) => (
                                <Option value={language.name}>
                                  {language.name}
                                </Option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name="releaseData"
                          label="Original release date"
                        >
                          <DatePicker style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Divider style={{ marginTop: 0 }} />
                    <Row>
                      <Col>
                        <Title level={5}>
                          Rating{" "}
                          <Tooltip title="Rating description text runs here like this">
                            <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                          </Tooltip>
                        </Title>
                      </Col>
                    </Row>
                    <Divider style={{ margin: "10px 0" }} />
                    {/* <Row gutter={30} align="middle">
                      <Col span={12}>
                        <Form.Item label="Rating system">
                          Suggested rating - Title not officially rated
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        <Form.Item name='ratingSystem' label="Rating system" required>
                          <Select
                            defaultValue="13+"
                            options={[
                              { value: 'pg', label: 'PG' },
                              { value: '13+', label: 'PG 13+' },
                              { value: '18+', label: 'Adult' },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={2}>
                        <Button
                          type="outline"
                          danger
                          size="small"
                          icon={<CloseOutlined />}
                          shape="circle"
                        />
                      </Col>
                    </Row>
                    <Divider style={{ margin: '0 0 20px 0' }} />
                    <Row>
                      <Col span={24}>
                        <Form.Item label="Rating system" noStyle>
                          <Select
                            defaultValue="addRating"
                            options={[
                              { value: 'addRating', label: 'Add rating' },
                              { value: 'rating1', label: 'Rating 1' },
                              { value: 'rating2', label: 'Rating 2' },
                            ]}
                          />
                        </Form.Item>
                        <Text
                          style={{ marginLeft: '10px', fontStyle: 'italic' }}
                        >
                          To add an official rating, please remove the
                          Suggested Rating.
                        </Text>
                      </Col>
                    </Row> */}
                    <Row>
                      <Col span={26}>
                        <Space
                          style={{
                            display: "flex",
                            marginBottom: 8,
                          }}
                          align="baseline"
                        >
                          <Col span={18}>
                            <Form.Item
                              name={"ratingType"}
                              label="Rating System"
                              initialValue={ratingType}
                            >
                              <Select
                                style={{ width: "350px" }}
                                onChange={setRatingType}
                                defaultValue={"CBFC"}
                              >
                                {ratings.map((r) => (
                                  <Select.Option key={r.value}>
                                    {r.type}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={10}>
                            <Form.Item name={"rating"} label="Rating">
                              <Select style={{ width: "100px" }}>
                                {ratingType &&
                                  ratingValues &&
                                  ratingValues.map((v) => (
                                    <Select.Option key={v.key}>
                                      {v.value}
                                    </Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Space>
                        {/* <Form.List name="rating">
                          {(fields, { add, remove }) => (
                            <>
                              <Space
                                style={{
                                  display: 'flex',
                                  marginBottom: 8,
                                }}
                                align="baseline"
                              >
                                <Col span={18}>
                                  <Form.Item
                                    name={'ratingType'}
                                    label="Rating System"
                                    initialValue={ratingType}
                                  >
                                    <Select style={{ width: '350px' }} onChange={setRatingType} defaultValue={'CBFC'}>
                                      {ratings.map((r) => (
                                        <Select.Option key={r.value}>{r.type}</Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={10}>
                                  <Form.Item
                                    name={'rating'}
                                    label='Rating'
                                  >
                                    <Select style={{ width: '100px' }}>
                                      {ratingType && ratingValues && ratingValues.map((v) => (
                                        <Select.Option key={v.key}>{v.value}</Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Space>
                              {fields.map(({ key, name, ...restField }) => (
                                <Space
                                  key={key}
                                  style={{
                                    display: 'flex',
                                    marginBottom: 8,
                                  }}
                                  align="baseline"
                                >
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'ratingType']}
                                    label="Rating System"
                                    noStyle
                                  >
                                    <Select style={{ width: '350px' }} onChange={setRatingType} defaultValue={'CBFC'}>
                                      {ratings.map((r) => (
                                        <Select.Option key={r.value}>{r.type}</Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'rating']}
                                    label='Rating'
                                    noStyle
                                  >
                                    <Select style={{ width: '100px' }}>
                                      {ratingType && ratingValues && ratingValues.map((v) => (
                                        <Select.Option key={v.key}>{v.value}</Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  <MinusCircleOutlined onClick={() => remove(name)} />
                                </Space>
                              ))}
                              <Form.Item>
                                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                  Add field
                                </Button>
                              </Form.Item>
                            </>
                          )}
                        </Form.List> */}
                      </Col>
                    </Row>
                    <Divider />
                    <Row>
                      <Col>
                        <Title level={5}>
                          Graphic assets{" "}
                          <Tooltip title="Rating description text runs here like this">
                            <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                          </Tooltip>
                        </Title>
                        <Text>
                          Key art (also known as cover or the title art)
                          represents your title on Prime Video.{" "}
                          <strong>
                            Please include legible titles on your key art.
                          </strong>{" "}
                          The optional background image adds visual interests to
                          video detail pages. For additional detail and
                          examples. See the{" "}
                          <Link href="#">Graphic Assets Guide.</Link>
                        </Text>
                      </Col>
                    </Row>

                    <Row gutter={30} style={{ marginTop: "20px" }}>
                      {/* 16:9 Image */}
                      <Col span="8">
                        <Row>
                          <Col span={24}>
                            <Text>
                              <strong>Key art</strong> (16:9){" "}
                              <Tooltip title="Some description text runs here like this">
                                <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                              </Tooltip>
                            </Text>
                          </Col>
                          <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                            <Button size="small">Browse...</Button>{" "}
                            <Button size="small">Google Drive</Button>
                          </Col>
                          <Col span={24}>
                            <Divider style={{ margin: "5px 0" }} />
                          </Col>
                          <Col span={24}>
                            {detailImageUrl ? (
                              <Image
                                style={{
                                  aspectRatio: "16/9",
                                  objectFit: "contain",
                                }}
                                src={detailImageUrl}
                              />
                            ) : (
                              <Upload
                                // listType="picture-card"
                                showUploadList={false}
                                action={`${apiUrl}/uploads/cloudflare`}
                                headers={{
                                  authorization: `Bearer ${token}`,
                                }}
                                beforeUpload={beforeImageUpload}
                                onChange={handleDetailImageUploadStatusChange}
                              >
                                {
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                }
                              </Upload>
                            )}
                            {/* <Image
                              style={{
                                aspectRatio: '16/9',
                                objectFit: 'contain',
                              }}
                              src="https://images.unsplash.com/photo-1627383301770-4b9d861e6a66?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=70"
                            /> */}
                          </Col>
                        </Row>
                      </Col>

                      {/* 3:4 Image */}
                      <Col span="8">
                        <Row>
                          <Col span={24}>
                            <Text>
                              <strong>Key art</strong> (3:4){" "}
                              <Tooltip title="Some description text runs here like this">
                                <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                              </Tooltip>
                            </Text>
                          </Col>
                          <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                            <Button size="small">Browse...</Button>{" "}
                            <Button size="small">Google Drive</Button>
                          </Col>
                          <Col span={24}>
                            <Divider style={{ margin: "5px 0" }} />
                          </Col>
                          <Col span={24}>
                            {detailImageUrl ? (
                              <Image
                                style={{
                                  aspectRatio: "16/9",
                                  objectFit: "contain",
                                }}
                                src={detailImageUrl}
                              />
                            ) : (
                              <Upload
                                // listType="picture-card"
                                showUploadList={false}
                                action={`${apiUrl}/uploads/cloudflare`}
                                headers={{
                                  authorization: `Bearer ${token}`,
                                }}
                                beforeUpload={beforeImageUpload}
                                onChange={handleDetailImageUploadStatusChange}
                              >
                                {
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                }
                              </Upload>
                            )}
                            {/* <Image
                              style={{
                                aspectRatio: '3/4',
                                objectFit: 'contain',
                              }}
                              src="https://images.unsplash.com/photo-1567637825410-e1e2f8582f7f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80"
                            /> */}
                          </Col>
                        </Row>
                      </Col>

                      {/* Background Image */}
                      <Col span="8">
                        <Row>
                          <Col span={24}>
                            <Text>
                              Background Image (Optional){" "}
                              <Tooltip title="Some description text runs here like this">
                                <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                              </Tooltip>
                            </Text>
                          </Col>
                          <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                            <Button size="small">Browse...</Button>{" "}
                            <Button size="small">Google Drive</Button>
                          </Col>
                          <Col span={24}>
                            <Divider style={{ margin: "5px 0" }} />
                          </Col>
                          <Col span={24}>
                            {detailImageUrl ? (
                              <Image
                                style={{
                                  aspectRatio: "16/9",
                                  objectFit: "contain",
                                }}
                                src={detailImageUrl}
                              />
                            ) : (
                              <Upload
                                // listType="picture-card"
                                showUploadList={false}
                                action={`${apiUrl}/uploads/cloudflare`}
                                headers={{
                                  authorization: `Bearer ${token}`,
                                }}
                                beforeUpload={beforeImageUpload}
                                onChange={handleDetailImageUploadStatusChange}
                              >
                                {
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                }
                              </Upload>
                            )}
                            {/* <Image
                              style={{
                                aspectRatio: '16/9',
                                objectFit: 'contain',
                              }}
                              src="https://images.unsplash.com/photo-1627383301770-4b9d861e6a66?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=70"
                            /> */}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row justify="end" style={{ marginTop: "50px" }}>
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          style={{ padding: "0 20px" }}
                          onClick={handleContentInfoSubmit}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
                <TabPane tab="Cast & Crew" key="2">
                  <Form layout="vertical" form={castCrewAvailabilityForm}>
                    <Row gutter={30}>
                      <Col span={24}>
                        <Title level={4}>Studio/Creator</Title>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="studioName" label="Name" required>
                          {/* <Select
                            placeholder="Select studio Name here..."
                          // value={movie.studioName}
                          >
                            {directors && directors.map((d) => {
                              <Option key={d.key} value={d.name}>{d.name}</Option>
                            })}
                            {producers && producers.map((d) => {
                              <Option key={d.key} value={d.name}>{d.name}</Option>
                            })}
                          </Select> */}
                          <Select
                            placeholder="Select studio Name here..."
                            showSearch
                            mode="single"
                            value={movie.studioName ? movie.studioName : null}
                          >
                            {directors.map((director) => (
                              <Option key={director.name} value={director.name}>
                                {director.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}></Col>
                    </Row>
                    <Divider style={{ marginTop: 0 }} />
                    <Row>
                      <Col span={24}>
                        <Title level={4} style={{ marginBottom: "0" }}>
                          Crew
                        </Title>
                        <Text type="secondary">
                          At least one crew member is required
                        </Text>
                      </Col>
                      <Col span={24} style={{ marginTop: "15px" }}>
                        <Row gutter={30} align="top">
                          <Col span={7}>
                            <Row>
                              <Col span={24}>
                                <Form.Item
                                  name="directors"
                                  label="Directors"
                                  required
                                  dataIndex={"directors"}
                                >
                                  <Select
                                    placeholder="Select Directors here..."
                                    style={{ width: "100%" }}
                                    mode="multiple"
                                  >
                                    {directors &&
                                      directors.map((director) => (
                                        <Option value={director.name}>
                                          {director.name}
                                        </Option>
                                      ))}
                                  </Select>
                                </Form.Item>
                                <Form.Item
                                  name={"producers"}
                                  label="Producers"
                                  required
                                >
                                  <Select
                                    placeholder="Select Producers here..."
                                    style={{ width: "100%" }}
                                    mode="multiple"
                                    value={movie.producers}
                                  >
                                    {producers.map((producer) => (
                                      <Option
                                        key={producer.key}
                                        value={producer.name}
                                      >
                                        {producer.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Divider />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <Title level={4} style={{ marginBottom: "0" }}>
                              Cast
                            </Title>
                            <Text type="secondary">
                              The top two to four cast members provided below
                              will be indicated as Starring across Prime Video
                              apps.
                            </Text>
                          </Col>
                          <Col span={24} style={{ marginTop: "15px" }}>
                            <Row gutter={30} align="middle">
                              <Col span={7}>
                                <Row>
                                  <Col span={24}>Name</Col>
                                  <Col span={24}>
                                    <Form.Item
                                      name="actors"
                                      label="Actors"
                                      required
                                    >
                                      <Select
                                        placeholder="Select Actors here..."
                                        showSearch
                                        mode="multiple"
                                        className="form-card-selector"
                                        style={{ width: "100%" }}
                                        value={movie.actors}
                                      >
                                        {actors.map((actor) => (
                                          <Option
                                            key={actor.key}
                                            value={actor.name}
                                          >
                                            {actor.name}
                                          </Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                          {/* <Col span={7}>
                              <Row>
                                <Col span={24}>Character</Col>
                                <Col span={24}>
                                  <Form.Item label="Category" required noStyle>
                                    <Input placeholder="Enter title here..." />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col> */}
                          {/* <Col span={6}>
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginTop: '25px',
                                  marginRight: '10px',
                                }}
                                icon={<UpOutlined />}
                              />
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginTop: '25px',
                                  marginRight: '10px',
                                }}
                                icon={<DownOutlined />}
                              />
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginTop: '25px',
                                  marginLeft: '20px',
                                }}
                                icon={<CloseOutlined />}
                              />
                            </Col> */}
                        </Row>
                        {/* <Row
                            gutter={30}
                            align="middle"
                            style={{ marginTop: '20px' }}
                          >
                            <Col span={7}>
                              <Row>
                                <Col span={24}>
                                  <Form.Item label="Name" required noStyle>
                                    <Input placeholder="Enter title here..." />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={7}>
                              <Row>
                                <Col span={24}>
                                  <Form.Item label="Category" required noStyle>
                                    <Input placeholder="Enter title here..." />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={6}>
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginRight: '10px',
                                }}
                                icon={<UpOutlined />}
                              />
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginRight: '10px',
                                }}
                                icon={<DownOutlined />}
                              />
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginLeft: '20px',
                                }}
                                icon={<CloseOutlined />}
                              />
                            </Col>
                          </Row> */}
                        <Row gutter={30}>
                          {/* <Col span={24} style={{ marginTop: '15px' }}>
                              <Button size="small">Add crew member</Button>
                            </Col> */}
                        </Row>
                      </Col>
                      <Col span={24}>
                        <Divider />
                      </Col>
                    </Row>
                    <Row justify="end">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          style={{ padding: "0 20px" }}
                          onClick={handleCastCrewSubmit}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
                <TabPane tab="Video assets" key="videoAssets">
                  <Form layout="vertical">
                    <Row gutter={30}>
                      <Col span={24}>
                        <Title level={4}>
                          Video and Audio Files{" "}
                          <Tooltip title="Some description text runs here like this">
                            <span style={{ fontSize: "15px" }}>
                              <InfoCircleOutlined
                                size="small"
                                color="rgba(0, 0, 0, 0.45)"
                              />
                            </span>
                          </Tooltip>
                        </Title>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <Row gutter={30}>
                          <Col span={6}>Mezzanine</Col>
                          <Col span={6}>Raja_Rani_Movie.mp4</Col>
                          <Col span={6}>
                            <Select
                              style={{ width: "100%" }}
                              defaultValue="telugu"
                              options={[
                                {
                                  value: "telugu",
                                  label: "Telugu (India)",
                                },
                                { value: "hindi", label: "Hindi (India)" },
                                {
                                  value: "spanish",
                                  label: "Spanish (Spain)",
                                },
                              ]}
                            />
                          </Col>
                          <Col span={6}>
                            <Button style={{ marginRight: "10px" }}>
                              Browse...
                            </Button>
                            <Button>Google Drive</Button>
                          </Col>
                        </Row>
                        <Row gutter={30} style={{ marginTop: "20px" }}>
                          <Col span={6}>Trailer (optional)</Col>
                          <Col span={6}></Col>
                          <Col span={6}>
                            <Select
                              style={{ width: "100%" }}
                              defaultValue="telugu"
                              disabled
                              options={[
                                {
                                  value: "telugu",
                                  label: "Telugu (India)",
                                },
                                { value: "hindi", label: "Hindi (India)" },
                                {
                                  value: "spanish",
                                  label: "Spanish (Spain)",
                                },
                              ]}
                            />
                          </Col>
                          <Col span={6}>
                            <Button style={{ marginRight: "10px" }}>
                              Browse...
                            </Button>
                            <Button>Google Drive</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <Divider style={{ margin: "10px 0" }} />
                      </Col>
                      <Col span={24}>
                        <Button>Add audio file</Button>
                      </Col>
                    </Row>

                    <Row gutter={30} style={{ marginTop: "30px" }}>
                      <Col span={24}>
                        <Title level={4}>
                          Timed Text{" "}
                          <Tooltip title="Some description text runs here like this">
                            <span style={{ fontSize: "15px" }}>
                              <InfoCircleOutlined
                                size="small"
                                color="rgba(0, 0, 0, 0.45)"
                              />
                            </span>
                          </Tooltip>
                        </Title>
                      </Col>
                      <Col span={24}>
                        <Text type="warning" style={{ marginRight: "10px" }}>
                          <span>
                            <WarningFilled />
                          </span>{" "}
                          Missing English
                        </Text>
                        <Text type="warning" style={{ marginRight: "10px" }}>
                          <span>
                            <WarningFilled />
                          </span>{" "}
                          Missing English
                        </Text>
                      </Col>
                      <Divider style={{ margin: "7px 0" }} />
                      <Col span={24}>No Timed text files have been added</Col>
                      <Divider style={{ margin: "7px 0" }} />
                      <Col span={24}>
                        <Button>Add timed text</Button>
                      </Col>
                    </Row>

                    <Divider />
                    <Row gutter={30} style={{ marginTop: "30px" }}>
                      <Col span={24}>
                        <Title level={4}>
                          Stream{" "}
                          <Tooltip title="Some description text runs here like this">
                            <span style={{ fontSize: "15px" }}>
                              <InfoCircleOutlined
                                size="small"
                                color="rgba(0, 0, 0, 0.45)"
                              />
                            </span>
                          </Tooltip>
                        </Title>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          name="skipIntroStart"
                          label="Skip Intro Start"
                        >
                          <InputNumber
                            placeholder="Enter start time in seconds"
                            disabled={contentType === "song"}
                            min={1}
                            max={18000}
                          />
                        </Form.Item>
                        <Form.Item name="skipIntroEnd" label="Skip Intro End">
                          <InputNumber
                            placeholder="Enter end time in seconds"
                            disabled={contentType === "song"}
                            min={1}
                            max={18000}
                          />
                        </Form.Item>
                      </Col>
                      <Divider style={{ margin: "7px 0" }} />
                      <Col span={24}></Col>
                    </Row>

                    <Divider />

                    <Row justify="end">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button type="primary" style={{ padding: "0 20px" }}>
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
                <TabPane tab="Availability" key="4">
                  {/* <Row style={{ marginTop: '20px' }}>
                    <Col span={24}>
                      <Title level={5}>
                        Where and how can Amazon customers watch this title?{' '}
                        <Tooltip title="Some description text runs here like this">
                          <span style={{ fontSize: '15px' }}>
                            <InfoCircleOutlined
                              size="small"
                              color="rgba(0, 0, 0, 0.45)"
                            />
                          </span>
                        </Tooltip>
                      </Title>
                      <p>
                        <Text>
                          Set where this title can be viewed, offer types, and
                          availability dates.
                        </Text>
                      </p>
                      <p>
                        <Text>
                          Eligible locations are basedon the title's metadata
                          languages and require, audio, or caption file
                          matching each language. Additional requirements are
                          displayed. <a href="#">Learn more</a>
                        </Text>
                      </p>
                      <p>
                        <Text>
                          Note: All audio and timed text files added to this
                          title will be published to all selected territories.
                          You should only distribute localized assets into
                          territories for which you have rights.{' '}
                          <a href="#">Learn more</a>
                        </Text>
                      </p>
                    </Col>
                  </Row> */}
                  {/* Locations Table  */}
                  <Row>
                    <Col span={24}>
                      {/* <Table
                        columns={availableTableColummns}
                        dataSource={availableTableData}
                      /> */}
                      <Form layout="vertical" form={geoAccessForm}>
                        <Form.Item
                          name="listType"
                          label={"Content access"}
                          rules={[{ required: true }]}
                          style={{ marginTop: "2%" }}
                          noStyle
                          initialValue={"allow_all"}
                        >
                          <Radio.Group
                            value={listType}
                            onChange={(e) => setListType(e.target.value)}
                            defaultValue={"allow_all"}
                            style={{ marginTop: "1%" }}
                          >
                            <Radio value="allow_all">Allow Globally</Radio>
                            <Radio value="allow">Allow List</Radio>
                            <Radio value="disallow">Deny List</Radio>
                          </Radio.Group>
                        </Form.Item>

                        {["allow", "disallow"].includes(listType) && (
                          <Form.Item
                            name={`countryMap`}
                            label={"Countries"}
                            rules={[{ required: true }]}
                            style={{ width: "100%", marginTop: "1%" }}
                          >
                            <Select
                              showSearch
                              mode="multiple"
                              placeholder={`Select countries to be ${listType}ed..`}
                              style={{ width: "100%" }}
                            >
                              {Object.entries(countryCodes).map(
                                ([code, name]) => (
                                  <Option key={code} value={code}>
                                    {name}
                                  </Option>
                                )
                              )}
                            </Select>
                          </Form.Item>
                        )}
                      </Form>
                    </Col>
                  </Row>
                  <Divider />
                  {/* Pricing Model Block */}
                  <Row>
                    <Col span={24}>
                      <Text>
                        <strong>
                          Which business model do you want to use?{" "}
                        </strong>
                        <Tooltip title="Some description text runs here like this">
                          <span style={{ fontSize: "15px" }}>
                            <InfoCircleOutlined
                              size="small"
                              color="rgba(0, 0, 0, 0.45)"
                            />
                          </span>
                        </Tooltip>
                      </Text>
                    </Col>
                    <Form layout="vertical" form={monetizationStreamingForm}>
                      <Row style={{ marginTop: "10px", marginBottom: "10px" }}>
                        <Radio.Group
                          onChange={(e) => {
                            setModelType(e.target.value);
                            console.log(e.target.value);
                          }}
                          defaultValue="default"
                        >
                          <Radio value={"default"}>Default</Radio>
                          <Radio value={"1"}>Subsciption & Free</Radio>
                          <Radio value={"2"}>Buy & Rent</Radio>
                          <Radio value={"3"}>Subsciption, Free & Rent</Radio>
                        </Radio.Group>
                      </Row>
                      {modelType === "default" && <Row></Row>}
                      {modelType === "1" && (
                        <Row>
                          <Radio.Group
                            onChange={(e) =>
                              setMonetizationModel(e.target.value)
                            }
                          >
                            <Radio value={"subscription"}>Subscription</Radio>
                            <Radio value={"free"}>Free</Radio>
                          </Radio.Group>
                        </Row>
                      )}
                      {modelType === "2" && (
                        <Row>
                          <Form.List name="currencyMap">
                            {(fields, { add, remove }) => (
                              <>
                                <Space
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                  }}
                                  align="baseline"
                                >
                                  <Form.Item
                                    name={"def_currency_1"}
                                    label="Currency"
                                    style={{ width: "100%" }}
                                    className="form-item-selector"
                                  >
                                    <Select
                                      style={{ width: "200px" }}
                                      defaultValue={"INR"}
                                    >
                                      {codes.map((cc) => (
                                        <Select.Option
                                          key={cc}
                                          value={cc}
                                          placeholder={"Select a Currency"}
                                        >
                                          {currencycodes[cc]}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  <Form.Item name={"def_mrp_1"} label="MRP">
                                    <InputNumber placeholder="Enter amount" />
                                  </Form.Item>
                                </Space>
                                <Space
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                    marginTop: -15,
                                  }}
                                  align="baseline"
                                >
                                  <Form.Item
                                    name={"def_currency_2"}
                                    label="Currency"
                                    style={{ width: "100%" }}
                                    className="form-item-selector"
                                    noStyle
                                  >
                                    <Select
                                      style={{ width: "200px" }}
                                      defaultValue={"USD"}
                                    >
                                      {codes.map((cc) => (
                                        <Select.Option
                                          key={cc}
                                          value={cc}
                                          placeholder={"Select a Currency"}
                                        >
                                          {currencycodes[cc]}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  <Form.Item
                                    name={"def_mrp_2"}
                                    label="MRP"
                                    noStyle
                                  >
                                    <InputNumber placeholder="Enter amount" />
                                  </Form.Item>
                                </Space>
                                {fields.map(({ key, name, ...restField }) => (
                                  <Space
                                    key={key}
                                    style={{
                                      display: "flex",
                                      marginTop: 8,
                                      marginBottom: 8,
                                      width: "100%",
                                    }}
                                    align="baseline"
                                  >
                                    <Form.Item
                                      {...restField}
                                      name={[name, "currency"]}
                                      label="Currency"
                                      style={{
                                        width: "100%",
                                        columnWidth: "40%",
                                      }}
                                      className="form-item-selector"
                                      noStyle
                                    >
                                      <Select
                                        style={{ width: "200px" }}
                                        placeholder={"Select a Currency"}
                                      >
                                        {codes.map((cc) => (
                                          <Select.Option
                                            key={cc}
                                            value={cc}
                                            placeholder={"Select a Currency"}
                                          >
                                            {currencycodes[cc]}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                    <Form.Item
                                      {...restField}
                                      name={[name, "mrp"]}
                                      label="MRP"
                                      noStyle
                                    >
                                      <InputNumber placeholder="Enter amount" />
                                    </Form.Item>
                                    {fields.length > 0 &&
                                      key === fields.length - 1 &&
                                      fields.length <= 6 && (
                                        <>
                                          <PlusCircleOutlined
                                            onClick={() => add()}
                                          />
                                          <MinusCircleOutlined
                                            onClick={() => remove(name)}
                                          />
                                        </>
                                      )}
                                  </Space>
                                ))}
                                {fields.length === 0 && (
                                  <Form.Item style={{ marginTop: 8 }}>
                                    <Button
                                      type="dashed"
                                      onClick={() => add()}
                                      block
                                      icon={<PlusOutlined />}
                                    >
                                      Add currency
                                    </Button>
                                  </Form.Item>
                                )}
                              </>
                            )}
                          </Form.List>
                        </Row>
                      )}
                      {modelType === "3" && (
                        <Row justify={"center"}>
                          <Col span={24}>
                            <Form.Item name="model">
                              <Radio.Group
                                style={{ marginTop: "1%" }}
                                onChange={(e) =>
                                  setMonetizationModel(e.target.value)
                                }
                              >
                                <Radio value="rent">Rent</Radio>
                                <Radio value="subscription">Subscription</Radio>
                                <Radio value="free">Free</Radio>
                              </Radio.Group>
                            </Form.Item>
                            {monetizationModel === "rent" && (
                              <>
                                <Form.List name="currencyMap">
                                  {(fields, { add, remove }) => (
                                    <>
                                      <Space
                                        style={{
                                          display: "flex",
                                          width: "100%",
                                        }}
                                        align="baseline"
                                      >
                                        <Form.Item
                                          name={"def_currency_1"}
                                          label="Currency"
                                          style={{ width: "100%" }}
                                          className="form-item-selector"
                                        >
                                          <Select
                                            style={{ width: "200px" }}
                                            defaultValue={"INR"}
                                          >
                                            {codes.map((cc) => (
                                              <Select.Option
                                                key={cc}
                                                value={cc}
                                                placeholder={
                                                  "Select a Currency"
                                                }
                                              >
                                                {currencycodes[cc]}
                                              </Select.Option>
                                            ))}
                                          </Select>
                                        </Form.Item>
                                        <Form.Item
                                          name={"def_mrp_1"}
                                          label="MRP"
                                        >
                                          <InputNumber placeholder="Enter amount" />
                                        </Form.Item>
                                      </Space>
                                      <Space
                                        style={{
                                          display: "flex",
                                          width: "100%",
                                          marginTop: -15,
                                        }}
                                        align="baseline"
                                      >
                                        <Form.Item
                                          name={"def_currency_2"}
                                          label="Currency"
                                          style={{ width: "100%" }}
                                          className="form-item-selector"
                                          noStyle
                                        >
                                          <Select
                                            style={{ width: "200px" }}
                                            defaultValue={"USD"}
                                          >
                                            {codes.map((cc) => (
                                              <Select.Option
                                                key={cc}
                                                value={cc}
                                                placeholder={
                                                  "Select a Currency"
                                                }
                                              >
                                                {currencycodes[cc]}
                                              </Select.Option>
                                            ))}
                                          </Select>
                                        </Form.Item>
                                        <Form.Item
                                          name={"def_mrp_2"}
                                          label="MRP"
                                          noStyle
                                        >
                                          <InputNumber placeholder="Enter amount" />
                                        </Form.Item>
                                      </Space>
                                      {fields.map(
                                        ({ key, name, ...restField }) => (
                                          <Space
                                            key={key}
                                            style={{
                                              display: "flex",
                                              marginTop: 8,
                                              marginBottom: 8,
                                              width: "100%",
                                            }}
                                            align="baseline"
                                          >
                                            <Form.Item
                                              {...restField}
                                              name={[name, "currency"]}
                                              label="Currency"
                                              style={{
                                                width: "100%",
                                                columnWidth: "40%",
                                              }}
                                              className="form-item-selector"
                                              noStyle
                                            >
                                              <Select
                                                style={{ width: "200px" }}
                                                placeholder={
                                                  "Select a Currency"
                                                }
                                              >
                                                {codes.map((cc) => (
                                                  <Select.Option
                                                    key={cc}
                                                    value={cc}
                                                    placeholder={
                                                      "Select a Currency"
                                                    }
                                                  >
                                                    {currencycodes[cc]}
                                                  </Select.Option>
                                                ))}
                                              </Select>
                                            </Form.Item>
                                            <Form.Item
                                              {...restField}
                                              name={[name, "mrp"]}
                                              label="MRP"
                                              noStyle
                                            >
                                              <InputNumber placeholder="Enter amount" />
                                            </Form.Item>
                                            {fields.length > 0 &&
                                              key === fields.length - 1 &&
                                              fields.length <= 6 && (
                                                <>
                                                  <PlusCircleOutlined
                                                    onClick={() => add()}
                                                  />
                                                  <MinusCircleOutlined
                                                    onClick={() => remove(name)}
                                                  />
                                                </>
                                              )}
                                          </Space>
                                        )
                                      )}
                                      {fields.length === 0 && (
                                        <Form.Item style={{ marginTop: 8 }}>
                                          <Button
                                            type="dashed"
                                            onClick={() => add()}
                                            block
                                            icon={<PlusOutlined />}
                                          >
                                            Add currency
                                          </Button>
                                        </Form.Item>
                                      )}
                                    </>
                                  )}
                                </Form.List>
                              </>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Form>
                  </Row>
                  <Divider />
                  <Row justify="end">
                    <Col span={24} style={{ textAlign: "right" }}>
                      <Button
                        type="primary"
                        style={{ padding: "0 20px" }}
                        onClick={handleAvailabilitySubmit}
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </Col>
          </Row>
        )}
        {/* Adding details content for Episodes series */}
        {addSeriesContent && (
          <Row>
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <Row>
                    <Col span={24}>
                      <Title level={3} style={{ marginBottom: "10px" }}>
                        {seriesId.title}
                      </Title>
                      <Text type="secondary">
                        :
                        <>
                          <Tag
                            color="blue"
                            style={{
                              borderRadius: "100px",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                          >
                            English
                          </Tag>
                          {Telugu && (
                            <Tag
                              color="blue"
                              style={{
                                borderRadius: "100px",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              Telugu
                            </Tag>
                          )}
                          {Hindi && (
                            <Tag
                              color="blue"
                              style={{
                                borderRadius: "100px",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              Hindi
                            </Tag>
                          )}
                        </>
                        <Popover
                          content={addLanguagePopover}
                          trigger="click"
                          placement="bottom"
                          title="Add a Language"
                        >
                          <Button
                            size="small"
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                          >
                            Add
                          </Button>
                        </Popover>
                      </Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={24} style={{ marginTop: "15px" }}>
              <Tabs
                //  activeKey="catalogListing"
                className="add-content-tabs addContentTabs"
              >
                <TabPane
                  tab={<label>Catalog Listing</label>}
                  activeKey={activeKey}
                  key="1"
                >
                  <Form layout="vertical" form={seriesContentInfoForm}>
                    <Row>
                      <Col span={12}>
                        <Form.Item
                          name={"season"}
                          label="Season number"
                          required
                        >
                          <InputNumber
                            placeholder="Enter season number here..."
                            value={seriesId.season ? seriesId.season : 1}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <Form.Item
                          name="description"
                          label="Synopsis"
                          required
                          dataIndex={"description"}
                        >
                          <TextArea
                            placeholder="Enter Synopsis here..."
                            tooltip="Some information about this title displays here"
                            extra="English"
                            showCount
                            maxLength={400}
                            rows="4"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    {Telugu && (
                      <Row gutter={30}>
                        <Col span={24}>
                          <Form.Item
                            name={"teluguDescription"}
                            dataIndex={"teluguDescription"}
                            label="Synopsis (Telugu)"
                            required
                            tooltip="Some information about this title displays here"
                          >
                            <TextArea
                              rows={4}
                              placeholder="Enter short description of the movie"
                              showCount
                              maxLength={100}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    {Hindi && (
                      <Row gutter={30}>
                        <Col span={24}>
                          <Form.Item
                            name={"hindiDescription"}
                            dataIndex={"hindiDescription"}
                            label="Synopsis (Hindi)"
                            required
                            tooltip="Some information about this title displays here"
                          >
                            <TextArea
                              rows={4}
                              placeholder="Enter short description of the movie"
                              showCount
                              maxLength={100}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    {Tamil && (
                      <Row gutter={30}>
                        <Col span={24}>
                          <Form.Item
                            name={"tamilDescription"}
                            dataIndex={"tamilDescription"}
                            label="Synopsis (Tamil)"
                            required
                            tooltip="Some information about this title displays here"
                          >
                            <TextArea
                              rows={4}
                              placeholder="Enter short description of the movie"
                              showCount
                              maxLength={100}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    <Row gutter={30}>
                      <Col span={24}>
                        <Form.Item
                          name={"genre"}
                          label="Genre"
                          required
                          tooltip="Some information about this title displays here"
                          extra="2 genres remaining"
                          dataIndex={"genre"}
                        >
                          <Select mode="multiple" showSearch>
                            {genres &&
                              genres.map((genre) => (
                                <Option value={genre.name}>{genre.name}</Option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={30}>
                      <Col span={24}>
                        <Form.Item
                          name={"originCountry"}
                          dataIndex={"originCountry"}
                          label="Country/Region of origin"
                          required
                          tooltip="Some information about this title displays here"
                          extra="The order of countries/regions is important, with the first entry corresponding to the production company with the greatest contribution to the title."
                        >
                          <Select placeholder={"Select a country"} showSearch>
                            {Object.entries(countryCodes).map(
                              ([code, name]) => (
                                <Option key={code} value={code}>
                                  {name}
                                </Option>
                              )
                            )}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={30}>
                      <Col span={12}>
                        <Form.Item
                          name={"language"}
                          label="Original language (Optional)"
                          tooltip="Some information about this title displays here"
                        >
                          <Select
                            placeholder="Select a language"
                            mode="multiple"
                            showSearch
                          >
                            {languages &&
                              languages.map((language) => (
                                <Option value={language.name}>
                                  {language.name}
                                </Option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          // name="releaseDate"
                          label="Original release date"
                          // dataindex="releaseDate"
                        >
                          <DatePicker
                            format={"YYYY-MM-DD"}
                            // value={dateString}
                            style={{ width: "100%" }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Divider style={{ marginTop: 0 }} />
                    <Row>
                      <Col>
                        <Title level={5}>
                          Rating{" "}
                          <Tooltip title="Rating description text runs here like this">
                            <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                          </Tooltip>
                        </Title>
                      </Col>
                    </Row>
                    <Divider style={{ margin: "10px 0" }} />
                    {/* <Row gutter={30} align="middle">
                      <Col span={12}>
                        <Form.Item label="Rating system">
                          Suggested rating - Title not officially rated
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        <Form.Item label="Rating system" required>
                          <Select
                            defaultValue="13+"
                            options={[
                              { value: 'pg', label: 'PG' },
                              { value: '13+', label: 'PG 13+' },
                              { value: '18+', label: 'Adult' },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={2}>
                        <Button
                          type="outline"
                          danger
                          size="small"
                          icon={<CloseOutlined />}
                          shape="circle"
                        />
                      </Col>
                    </Row> */}
                    <Row>
                      <Col span={26}>
                        <Space
                          style={{
                            display: "flex",
                            marginBottom: 8,
                          }}
                          align="baseline"
                        >
                          <Col span={18}>
                            <Form.Item
                              name={"ratingType"}
                              label="Rating System"
                              initialValue={ratingType}
                            >
                              <Select
                                style={{ width: "350px" }}
                                onChange={setRatingType}
                                defaultValue={"CBFC"}
                              >
                                {ratings.map((r) => (
                                  <Select.Option key={r.value}>
                                    {r.type}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={10}>
                            <Form.Item name={"rating"} label="Rating">
                              <Select style={{ width: "100px" }}>
                                {ratingType &&
                                  ratingValues &&
                                  ratingValues.map((v) => (
                                    <Select.Option key={v.key}>
                                      {v.value}
                                    </Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Space>
                        {/* <Form.List name="rating">
                          {(fields, { add, remove }) => (
                            <>
                              <Space
                                style={{
                                  display: 'flex',
                                  marginBottom: 8,
                                }}
                                align="baseline"
                              >
                                <Col span={18}>
                                  <Form.Item
                                    name={'ratingType'}
                                    label="Rating System"
                                    initialValue={ratingType}
                                  >
                                    <Select style={{ width: '350px' }} onChange={setRatingType} defaultValue={'CBFC'}>
                                      {ratings.map((r) => (
                                        <Select.Option key={r.value}>{r.type}</Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={10}>
                                  <Form.Item
                                    name={'rating'}
                                    label='Rating'
                                  >
                                    <Select style={{ width: '100px' }}>
                                      {ratingType && ratingValues && ratingValues.map((v) => (
                                        <Select.Option key={v.key}>{v.value}</Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Space>
                              {fields.map(({ key, name, ...restField }) => (
                                <Space
                                  key={key}
                                  style={{
                                    display: 'flex',
                                    marginBottom: 8,
                                  }}
                                  align="baseline"
                                >
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'ratingType']}
                                    label="Rating System"
                                    noStyle
                                  >
                                    <Select style={{ width: '350px' }} onChange={setRatingType} defaultValue={'CBFC'}>
                                      {ratings.map((r) => (
                                        <Select.Option key={r.value}>{r.type}</Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'rating']}
                                    label='Rating'
                                    noStyle
                                  >
                                    <Select style={{ width: '100px' }}>
                                      {ratingType && ratingValues && ratingValues.map((v) => (
                                        <Select.Option key={v.key}>{v.value}</Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  <MinusCircleOutlined onClick={() => remove(name)} />
                                </Space>
                              ))}
                              <Form.Item>
                                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                  Add field
                                </Button>
                              </Form.Item>
                            </>
                          )}
                        </Form.List> */}
                      </Col>
                    </Row>
                    <Divider />
                    {/* <Divider style={{ margin: '0 0 20px 0' }} />
                    <Row>
                      <Col span={24}>
                        <Form.Item label="Rating system" noStyle>
                          <Select
                            defaultValue="addRating"
                            options={[
                              { value: 'addRating', label: 'Add rating' },
                              { value: 'rating1', label: 'Rating 1' },
                              { value: 'rating2', label: 'Rating 2' },
                            ]}
                          />
                        </Form.Item>
                        <Text
                          style={{ marginLeft: '10px', fontStyle: 'italic' }}
                        >
                          To add an official rating, please remove the
                          Suggested Rating.
                        </Text>
                      </Col>
                    </Row> */}
                    <Row>
                      <Col>
                        <Title level={5}>
                          Graphic assets{" "}
                          <Tooltip title="Rating description text runs here like this">
                            <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                          </Tooltip>
                        </Title>
                        <Text>
                          Key art (also known as cover or the title art)
                          represents your title on Prime Video.{" "}
                          <strong>
                            Please include legible titles on your key art.
                          </strong>{" "}
                          The optional background image adds visual interests to
                          video detail pages. For additional detail and
                          examples. See the{" "}
                          <Link href="#">Graphic Assets Guide.</Link>
                        </Text>
                      </Col>
                    </Row>

                    <Row gutter={30} style={{ marginTop: "20px" }}>
                      {/* 16:9 Image */}
                      <Col span="8">
                        <Row>
                          <Col span={24}>
                            <Text>
                              <strong>Key art</strong> (16:9){" "}
                              <Tooltip title="Some description text runs here like this">
                                <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                              </Tooltip>
                            </Text>
                          </Col>
                          <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                            <Button size="small">Browse...</Button>{" "}
                            <Button size="small">Google Drive</Button>
                          </Col>
                          <Col span={24}>
                            <Divider style={{ margin: "5px 0" }} />
                          </Col>
                          <Col span={24}>
                            {detailImageUrl ? (
                              <Image
                                style={{
                                  aspectRatio: "16/9",
                                  objectFit: "contain",
                                }}
                                src={detailImageUrl}
                              />
                            ) : (
                              <Upload
                                // listType="picture-card"
                                showUploadList={false}
                                action={`${apiUrl}/uploads/cloudflare`}
                                headers={{
                                  authorization: `Bearer ${token}`,
                                }}
                                beforeUpload={beforeImageUpload}
                                onChange={handleDetailImageUploadStatusChange}
                              >
                                {
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                }
                              </Upload>
                            )}
                            {/* <Image
                              style={{
                                aspectRatio: '16/9',
                                objectFit: 'contain',
                              }}
                              src="https://images.unsplash.com/photo-1627383301770-4b9d861e6a66?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=70"
                            /> */}
                          </Col>
                        </Row>
                      </Col>

                      {/* 3:4 Image */}
                      <Col span="8">
                        <Row>
                          <Col span={24}>
                            <Text>
                              <strong>Key art</strong> (3:4){" "}
                              <Tooltip title="Some description text runs here like this">
                                <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                              </Tooltip>
                            </Text>
                          </Col>
                          <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                            <Button size="small">Browse...</Button>{" "}
                            <Button size="small">Google Drive</Button>
                          </Col>
                          <Col span={24}>
                            <Divider style={{ margin: "5px 0" }} />
                          </Col>
                          <Col span={24}>
                            {detailImageUrl ? (
                              <Image
                                style={{
                                  aspectRatio: "16/9",
                                  objectFit: "contain",
                                }}
                                src={detailImageUrl}
                              />
                            ) : (
                              <Upload
                                // listType="picture-card"
                                showUploadList={false}
                                action={`${apiUrl}/uploads/cloudflare`}
                                headers={{
                                  authorization: `Bearer ${token}`,
                                }}
                                beforeUpload={beforeImageUpload}
                                onChange={handleDetailImageUploadStatusChange}
                              >
                                {
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                }
                              </Upload>
                            )}
                            {/* <Image
                              style={{
                                aspectRatio: '3/4',
                                objectFit: 'contain',
                              }}
                              src="https://images.unsplash.com/photo-1567637825410-e1e2f8582f7f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80"
                            /> */}
                          </Col>
                        </Row>
                      </Col>

                      {/* Background Image */}
                      <Col span="8">
                        <Row>
                          <Col span={24}>
                            <Text>
                              Background Image (Optional){" "}
                              <Tooltip title="Some description text runs here like this">
                                <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                              </Tooltip>
                            </Text>
                          </Col>
                          <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                            <Button size="small">Browse...</Button>{" "}
                            <Button size="small">Google Drive</Button>
                          </Col>
                          <Col span={24}>
                            <Divider style={{ margin: "5px 0" }} />
                          </Col>
                          <Col span={24}>
                            {detailImageUrl ? (
                              <Image
                                style={{
                                  aspectRatio: "16/9",
                                  objectFit: "contain",
                                }}
                                src={detailImageUrl}
                              />
                            ) : (
                              <Upload
                                // listType="picture-card"
                                showUploadList={false}
                                action={`${apiUrl}/uploads/cloudflare`}
                                headers={{
                                  authorization: `Bearer ${token}`,
                                }}
                                beforeUpload={beforeImageUpload}
                                onChange={handleDetailImageUploadStatusChange}
                              >
                                {
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                }
                              </Upload>
                            )}
                            {/* <Image
                              style={{
                                aspectRatio: '16/9',
                                objectFit: 'contain',
                              }}
                              src="https://images.unsplash.com/photo-1627383301770-4b9d861e6a66?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=70"
                            /> */}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row justify="end" style={{ marginTop: "50px" }}>
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          style={{ padding: "0 20px" }}
                          onClick={handleSeriesContentInfoSubmit}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
                <TabPane tab="Cast & Crew" key="2">
                  <Form layout="vertical" form={seriesCastCrewAvailabilityForm}>
                    <Row gutter={30}>
                      <Col span={24}>
                        <Title level={4}>Studio/Creator</Title>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="studioName" label="Name" required>
                          <Select
                            placeholder="Select studio Name here..."
                            showSearch
                            mode="single"
                          >
                            {directors.map((director) => (
                              <Option key={director.key} value={director.name}>
                                {director.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}></Col>
                    </Row>
                    <Divider style={{ marginTop: 0 }} />
                    <Row>
                      <Col span={24}>
                        <Title level={4} style={{ marginBottom: "0" }}>
                          Crew
                        </Title>
                        <Text type="secondary">
                          At least one crew member is required
                        </Text>
                      </Col>
                      <Col span={24} style={{ marginTop: "15px" }}>
                        <Row gutter={30} align="top">
                          <Col span={7}>
                            <Row>
                              <Col span={24}>
                                <Form.Item
                                  name="directors"
                                  label="Directors"
                                  required
                                  dataIndex={"directors"}
                                >
                                  <Select
                                    placeholder="Select Directors here..."
                                    style={{ width: "100%" }}
                                    mode="multiple"
                                  >
                                    {directors &&
                                      directors.map((director) => (
                                        <Option value={director.name}>
                                          {director.name}
                                        </Option>
                                      ))}
                                  </Select>
                                </Form.Item>
                                <Form.Item
                                  name={"producers"}
                                  label="Producers"
                                  required
                                >
                                  <Select
                                    placeholder="Select Producers here..."
                                    style={{ width: "100%" }}
                                    mode="multiple"
                                    value={seriesId.producers}
                                  >
                                    {producers.map((producer) => (
                                      <Option
                                        key={producer.key}
                                        value={producer.name}
                                      >
                                        {producer.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Divider />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <Title level={4} style={{ marginBottom: "0" }}>
                              Cast
                            </Title>
                            <Text type="secondary">
                              The top two to four cast members provided below
                              will be indicated as Starring across Prime Video
                              apps.
                            </Text>
                          </Col>
                          <Col span={24} style={{ marginTop: "15px" }}>
                            <Row gutter={30} align="middle">
                              <Col span={7}>
                                <Row>
                                  <Col span={24}>Name</Col>
                                  <Col span={24}>
                                    <Form.Item
                                      name="actors"
                                      label="Actors"
                                      required
                                    >
                                      <Select
                                        placeholder="Select Actors here..."
                                        showSearch
                                        mode="multiple"
                                        className="form-card-selector"
                                        style={{ width: "100%" }}
                                        value={seriesId.actors}
                                      >
                                        {actors.map((actor) => (
                                          <Option
                                            key={actor.key}
                                            value={actor.name}
                                          >
                                            {actor.name}
                                          </Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                          {/* <Col span={7}>
                              <Row>
                                <Col span={24}>Character</Col>
                                <Col span={24}>
                                  <Form.Item label="Category" required noStyle>
                                    <Input placeholder="Enter title here..." />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col> */}
                          {/* <Col span={6}>
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginTop: '25px',
                                  marginRight: '10px',
                                }}
                                icon={<UpOutlined />}
                              />
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginTop: '25px',
                                  marginRight: '10px',
                                }}
                                icon={<DownOutlined />}
                              />
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginTop: '25px',
                                  marginLeft: '20px',
                                }}
                                icon={<CloseOutlined />}
                              />
                            </Col> */}
                        </Row>
                        {/* <Row
                            gutter={30}
                            align="middle"
                            style={{ marginTop: '20px' }}
                          >
                            <Col span={7}>
                              <Row>
                                <Col span={24}>
                                  <Form.Item label="Name" required noStyle>
                                    <Input placeholder="Enter title here..." />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={7}>
                              <Row>
                                <Col span={24}>
                                  <Form.Item label="Category" required noStyle>
                                    <Input placeholder="Enter title here..." />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={6}>
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginRight: '10px',
                                }}
                                icon={<UpOutlined />}
                              />
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginRight: '10px',
                                }}
                                icon={<DownOutlined />}
                              />
                              <Button
                                size="small"
                                shape="circle"
                                style={{
                                  marginLeft: '20px',
                                }}
                                icon={<CloseOutlined />}
                              />
                            </Col>
                          </Row> */}
                        <Row gutter={30}>
                          {/* <Col span={24} style={{ marginTop: '15px' }}>
                              <Button size="small">Add crew member</Button>
                            </Col> */}
                        </Row>
                      </Col>
                      <Col span={24}>
                        <Divider />
                      </Col>
                    </Row>
                    <Row justify="end">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          style={{ padding: "0 20px" }}
                          onClick={handleSeriesCastCrewSubmit}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
                <TabPane tab="Episodes" key="3">
                  {/* <Form layout="vertical" form={episodesForm}>
                    <Row>
                      <Col span={24}>
                        <Collapse>
                          <Panel
                            header="Episode 1"
                            key="1"
                            extra={episodesSortingButtons()}
                          >
                            <Row gutter={30}>
                              <Col span={17}>
                                <Form.Item name='title' label="Title">
                                  <Input
                                    placeholder="Enter title here..."
                                    value="Raja Rani Telugu Movie "
                                    extra="English"
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={7}>
                                <Form.Item name={'releaseDate'} label="Original release date">
                                  <DatePicker style={{ width: '100%' }} />
                                </Form.Item>
                              </Col>
                              <Col span={17}></Col>
                              <Col span={7}>
                                <Row>
                                  <Col span={24}>
                                    Key art (4:3) (Optional){' '}
                                    <Tooltip title="Some description text runs here like this">
                                      <span style={{ fontSize: '15px' }}>
                                        <InfoCircleOutlined
                                          size="small"
                                          color="rgba(0, 0, 0, 0.45)"
                                        />
                                      </span>
                                    </Tooltip>
                                  </Col>
                                  <Col span={24}>
                                    <Button>Browse...</Button>{' '}
                                    <Button>Google Drive</Button>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <Form.Item label="Synopsis" required>
                                  <TextArea
                                    name='description'
                                    placeholder="Enter title here..."
                                    value={''}
                                    tooltip="Some information about this title displays here"
                                    extra="English"
                                    showCount
                                    maxLength={400}
                                    rows="4"
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row gutter={30}>
                              <Col span={24}>
                                <Title level={4}>
                                  Video and Audio Files{' '}
                                  <Tooltip title="Some description text runs here like this">
                                    <span style={{ fontSize: '15px' }}>
                                      <InfoCircleOutlined
                                        size="small"
                                        color="rgba(0, 0, 0, 0.45)"
                                      />
                                    </span>
                                  </Tooltip>
                                </Title>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <Row gutter={30}>
                                  <Col span={6}>Mezzanine</Col>
                                  <Col span={6}>Raja_Rani_Movie.mp4</Col>
                                  <Col span={6}>
                                    <Select
                                      style={{ width: '100%' }}
                                      defaultValue="telugu"
                                      options={[
                                        {
                                          value: 'telugu',
                                          label: 'Telugu (India)',
                                        },
                                        {
                                          value: 'hindi',
                                          label: 'Hindi (India)',
                                        },
                                        {
                                          value: 'spanish',
                                          label: 'Spanish (Spain)',
                                        },
                                      ]}
                                    />
                                  </Col>
                                  <Col span={6}>
                                    <Button style={{ marginRight: '10px' }}>
                                      Browse...
                                    </Button>
                                    <Button>Google Drive</Button>
                                  </Col>
                                </Row>
                                <Row
                                  gutter={30}
                                  style={{ marginTop: '20px' }}
                                >
                                  <Col span={6}>Trailer (optional)</Col>
                                  <Col span={6}></Col>
                                  <Col span={6}>
                                    <Select
                                      style={{ width: '100%' }}
                                      defaultValue="telugu"
                                      disabled
                                      options={[
                                        {
                                          value: 'telugu',
                                          label: 'Telugu (India)',
                                        },
                                        {
                                          value: 'hindi',
                                          label: 'Hindi (India)',
                                        },
                                        {
                                          value: 'spanish',
                                          label: 'Spanish (Spain)',
                                        },
                                      ]}
                                    />
                                  </Col>
                                  <Col span={6}>
                                    <Button style={{ marginRight: '10px' }}>
                                      Browse...
                                    </Button>
                                    <Button>Google Drive</Button>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <Divider style={{ margin: '10px 0' }} />
                              </Col>
                              <Col span={24}>
                                <Button>Add audio file</Button>
                              </Col>
                            </Row>

                            <Row gutter={30} style={{ marginTop: '30px' }}>
                              <Col span={24}>
                                <Title level={4}>
                                  Timed Text{' '}
                                  <Tooltip title="Some description text runs here like this">
                                    <span style={{ fontSize: '15px' }}>
                                      <InfoCircleOutlined
                                        size="small"
                                        color="rgba(0, 0, 0, 0.45)"
                                      />
                                    </span>
                                  </Tooltip>
                                </Title>
                              </Col>
                              <Col span={24}>
                                <Text
                                  type="warning"
                                  style={{ marginRight: '10px' }}
                                >
                                  <span>
                                    <WarningFilled />
                                  </span>{' '}
                                  Missing English
                                </Text>
                                <Text
                                  type="warning"
                                  style={{ marginRight: '10px' }}
                                >
                                  <span>
                                    <WarningFilled />
                                  </span>{' '}
                                  Missing English
                                </Text>
                              </Col>
                              <Divider style={{ margin: '7px 0' }} />
                              <Col span={24}>
                                No Timed text files have been added
                              </Col>
                              <Divider style={{ margin: '7px 0' }} />
                              <Col span={24}>
                                <Button>Add timed text</Button>
                              </Col>
                            </Row>

                            <Divider />

                            <Row justify="end">
                              <Col span={24}>
                                <Checkbox>Delete this episode</Checkbox>
                              </Col>
                            </Row>
                          </Panel>
                          <Panel
                            header="Episode 2"
                            key="2"
                            extra={episodesSortingButtons()}
                          >
                            <Row gutter={30}>
                              <Col span={17}>
                                <Form.Item label="Title">
                                  <Input
                                    placeholder="Enter title here..."
                                    value="Raja Rani Telugu Movie "
                                    extra="English"
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={7}>
                                <Form.Item label="Original release date">
                                  <DatePicker style={{ width: '100%' }} />
                                </Form.Item>
                              </Col>
                              <Col span={17}></Col>
                              <Col span={7}>
                                <Row>
                                  <Col span={24}>
                                    Key art (4:3) (Optional){' '}
                                    <Tooltip title="Some description text runs here like this">
                                      <span style={{ fontSize: '15px' }}>
                                        <InfoCircleOutlined
                                          size="small"
                                          color="rgba(0, 0, 0, 0.45)"
                                        />
                                      </span>
                                    </Tooltip>
                                  </Col>
                                  <Col span={24}>
                                    <Button>Browse...</Button>{' '}
                                    <Button>Google Drive</Button>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <Form.Item label="Synopsis" required>
                                  <TextArea
                                    placeholder="Enter title here..."
                                    value="Raja Rani Telugu Movie "
                                    tooltip="Some information about this title displays here"
                                    extra="English"
                                    showCount
                                    maxLength={400}
                                    rows="4"
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row gutter={30}>
                              <Col span={24}>
                                <Title level={4}>
                                  Video and Audio Files{' '}
                                  <Tooltip title="Some description text runs here like this">
                                    <span style={{ fontSize: '15px' }}>
                                      <InfoCircleOutlined
                                        size="small"
                                        color="rgba(0, 0, 0, 0.45)"
                                      />
                                    </span>
                                  </Tooltip>
                                </Title>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <Row gutter={30}>
                                  <Col span={6}>Mezzanine</Col>
                                  <Col span={6}>Raja_Rani_Movie.mp4</Col>
                                  <Col span={6}>
                                    <Select
                                      style={{ width: '100%' }}
                                      defaultValue="telugu"
                                      options={[
                                        {
                                          value: 'telugu',
                                          label: 'Telugu (India)',
                                        },
                                        {
                                          value: 'hindi',
                                          label: 'Hindi (India)',
                                        },
                                        {
                                          value: 'spanish',
                                          label: 'Spanish (Spain)',
                                        },
                                      ]}
                                    />
                                  </Col>
                                  <Col span={6}>
                                    <Button style={{ marginRight: '10px' }}>
                                      Browse...
                                    </Button>
                                    <Button>Google Drive</Button>
                                  </Col>
                                </Row>
                                <Row
                                  gutter={30}
                                  style={{ marginTop: '20px' }}
                                >
                                  <Col span={6}>Trailer (optional)</Col>
                                  <Col span={6}></Col>
                                  <Col span={6}>
                                    <Select
                                      style={{ width: '100%' }}
                                      defaultValue="telugu"
                                      disabled
                                      options={[
                                        {
                                          value: 'telugu',
                                          label: 'Telugu (India)',
                                        },
                                        {
                                          value: 'hindi',
                                          label: 'Hindi (India)',
                                        },
                                        {
                                          value: 'spanish',
                                          label: 'Spanish (Spain)',
                                        },
                                      ]}
                                    />
                                  </Col>
                                  <Col span={6}>
                                    <Button style={{ marginRight: '10px' }}>
                                      Browse...
                                    </Button>
                                    <Button>Google Drive</Button>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <Divider style={{ margin: '10px 0' }} />
                              </Col>
                              <Col span={24}>
                                <Button>Add audio file</Button>
                              </Col>
                            </Row>

                            <Row gutter={30} style={{ marginTop: '30px' }}>
                              <Col span={24}>
                                <Title level={4}>
                                  Timed Text{' '}
                                  <Tooltip title="Some description text runs here like this">
                                    <span style={{ fontSize: '15px' }}>
                                      <InfoCircleOutlined
                                        size="small"
                                        color="rgba(0, 0, 0, 0.45)"
                                      />
                                    </span>
                                  </Tooltip>
                                </Title>
                              </Col>
                              <Col span={24}>
                                <Text
                                  type="warning"
                                  style={{ marginRight: '10px' }}
                                >
                                  <span>
                                    <WarningFilled />
                                  </span>{' '}
                                  Missing English
                                </Text>
                                <Text
                                  type="warning"
                                  style={{ marginRight: '10px' }}
                                >
                                  <span>
                                    <WarningFilled />
                                  </span>{' '}
                                  Missing English
                                </Text>
                              </Col>
                              <Divider style={{ margin: '7px 0' }} />
                              <Col span={24}>
                                No Timed text files have been added
                              </Col>
                              <Divider style={{ margin: '7px 0' }} />
                              <Col span={24}>
                                <Button>Add timed text</Button>
                              </Col>
                            </Row>

                            <Divider />

                            <Row justify="end">
                              <Col span={24}>
                                <Checkbox>Delete this episode</Checkbox>
                              </Col>
                            </Row>
                          </Panel>
                        </Collapse>
                      </Col>
                    </Row>
                    <Row justify="end" style={{ marginTop: '15px' }}>
                      <Col span={24}>
                        <Button type="primary" style={{ padding: '0 20px' }}>
                          Add episode
                        </Button>
                      </Col>
                    </Row>

                    <Divider />

                    <Row justify="end">
                      <Col span={24} style={{ textAlign: 'right' }}>
                        <Button type="primary" style={{ padding: '0 20px' }}>
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Form> */}
                  <Row>
                    <Col span={24}>
                      <Form layout="vertical" form={episodesForm}>
                        <Form.List name="episodes">
                          {(fields, { add, remove }) => (
                            <>
                              {fields.map(({ key, name, ...restField }) => (
                                <>
                                  <Collapse accordion>
                                    <Panel
                                      header={`Episode ${key + 1}`}
                                      key={key + 1}
                                      extra={episodesSortingButtons()}
                                    >
                                      <Row gutter={30}>
                                        <Form.Item
                                          {...restField}
                                          name={[name, "episode#"]}
                                          initialValue={key + 1}
                                          noStyle
                                        />
                                        <Col span={17}>
                                          <Form.Item
                                            {...restField}
                                            name={[name, "title"]}
                                            label="Title"
                                            required
                                          >
                                            <Input
                                              placeholder="Enter title here..."
                                              extra="English"
                                            />
                                          </Form.Item>
                                        </Col>
                                        <Col span={7}>
                                          <Form.Item
                                            {...restField}
                                            // name={[name, 'ep_release_date']}
                                            label="Original release date"
                                          >
                                            <DatePicker
                                              style={{ width: "100%" }}
                                            />
                                          </Form.Item>
                                        </Col>
                                        <Col span={17}>
                                          {Telugu && (
                                            <Row gutter={30}>
                                              <Col span={24}>
                                                <Form.Item
                                                  {...restField}
                                                  name={[name, "title_telugu"]}
                                                  label="Telugu Title"
                                                  required
                                                >
                                                  <Input
                                                    placeholder="Enter title here..."
                                                    // value={movie.TeluguTitle}
                                                  />
                                                </Form.Item>
                                              </Col>
                                            </Row>
                                          )}
                                          {Hindi && (
                                            <Row gutter={30}>
                                              <Col span={24}>
                                                <Form.Item
                                                  {...restField}
                                                  name={[name, "title_hindi"]}
                                                  label="Hindi Title"
                                                  required
                                                >
                                                  <Input
                                                    placeholder="Enter title here..."
                                                    // value={movie.HindiTitle}
                                                  />
                                                </Form.Item>
                                              </Col>
                                            </Row>
                                          )}
                                          {Tamil && (
                                            <Row gutter={30}>
                                              <Col span={24}>
                                                <Form.Item
                                                  {...restField}
                                                  name={[name, "title_tamil"]}
                                                  label="Tamil Title"
                                                  required
                                                >
                                                  <Input
                                                    placeholder="Enter title here..."
                                                    // value={movie.TamilTitle}
                                                  />
                                                </Form.Item>
                                              </Col>
                                            </Row>
                                          )}
                                        </Col>
                                        <Col span={7}>
                                          <Row>
                                            <Col span={24}>
                                              Key art (4:3) (Optional){" "}
                                              <Tooltip title="Some description text runs here like this">
                                                <span
                                                  style={{ fontSize: "15px" }}
                                                >
                                                  <InfoCircleOutlined
                                                    size="small"
                                                    color="rgba(0, 0, 0, 0.45)"
                                                  />
                                                </span>
                                              </Tooltip>
                                            </Col>
                                            <Col span={24}>
                                              <Button>Browse...</Button>{" "}
                                              <Button>Google Drive</Button>
                                            </Col>
                                            <Col>
                                              {detailImageUrl ? (
                                                <Image
                                                  style={{
                                                    aspectRatio: "16/9",
                                                    objectFit: "contain",
                                                  }}
                                                  src={detailImageUrl}
                                                />
                                              ) : (
                                                <Upload
                                                  // listType="picture-card"
                                                  showUploadList={false}
                                                  action={`${apiUrl}/uploads/cloudflare`}
                                                  headers={{
                                                    authorization: `Bearer ${token}`,
                                                  }}
                                                  beforeUpload={
                                                    beforeImageUpload
                                                  }
                                                  onChange={
                                                    handleDetailImageUploadStatusChange
                                                  }
                                                >
                                                  {
                                                    <Text
                                                      type="warning"
                                                      style={{
                                                        marginRight: "10px",
                                                      }}
                                                    >
                                                      <span>
                                                        <WarningFilled />
                                                      </span>{" "}
                                                      Click to Upload Image
                                                    </Text>
                                                  }
                                                </Upload>
                                              )}
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                      <Row></Row>
                                      <Row>
                                        <Col span={24}>
                                          <Form.Item
                                            {...restField}
                                            name={[name, "ep_description"]}
                                            label="Synopsis"
                                            required
                                          >
                                            <TextArea
                                              placeholder="Enter description here..."
                                              tooltip="Some information about this title displays here"
                                              extra="English"
                                              showCount
                                              maxLength={400}
                                              rows="4"
                                            />
                                          </Form.Item>
                                        </Col>
                                      </Row>
                                      {Telugu && (
                                        <Row gutter={30}>
                                          <Col span={24}>
                                            <Form.Item
                                              {...restField}
                                              name={[
                                                name,
                                                "ep_description_telugu",
                                              ]}
                                              label="Synopsis (Telugu)"
                                              required
                                            >
                                              <TextArea
                                                rows={4}
                                                placeholder="Enter short description of the movie"
                                                showCount
                                                maxLength={100}
                                              />
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                      )}
                                      {Hindi && (
                                        <Row gutter={30}>
                                          <Col span={24}>
                                            <Form.Item
                                              {...restField}
                                              name={[
                                                name,
                                                "ep_description_hindi",
                                              ]}
                                              label="Synopsis (Hindi)"
                                              required
                                            >
                                              <TextArea
                                                rows={4}
                                                placeholder="Enter short description of the movie"
                                                showCount
                                                maxLength={100}
                                              />
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                      )}
                                      {Tamil && (
                                        <Row gutter={30}>
                                          <Col span={24}>
                                            <Form.Item
                                              {...restField}
                                              name={[
                                                name,
                                                "ep_description_tamil",
                                              ]}
                                              label="Synopsis (Tamil)"
                                              required
                                            >
                                              <TextArea
                                                rows={4}
                                                placeholder="Enter short description of the movie"
                                                showCount
                                                maxLength={100}
                                              />
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                      )}
                                      <Row gutter={30}>
                                        <Col span={24}>
                                          <Title level={4}>
                                            Video and Audio Files{" "}
                                            <Tooltip title="Some description text runs here like this">
                                              <span
                                                style={{ fontSize: "15px" }}
                                              >
                                                <InfoCircleOutlined
                                                  size="small"
                                                  color="rgba(0, 0, 0, 0.45)"
                                                />
                                              </span>
                                            </Tooltip>
                                          </Title>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col span={24}>
                                          <Row gutter={30}>
                                            <Col span={6}>Mezzanine</Col>
                                            <Col span={6}>
                                              Raja_Rani_Movie.mp4
                                            </Col>
                                            <Col span={6}>
                                              <Select
                                                style={{ width: "100%" }}
                                                defaultValue="telugu"
                                                options={[
                                                  {
                                                    value: "telugu",
                                                    label: "Telugu (India)",
                                                  },
                                                  {
                                                    value: "hindi",
                                                    label: "Hindi (India)",
                                                  },
                                                  {
                                                    value: "spanish",
                                                    label: "Spanish (Spain)",
                                                  },
                                                ]}
                                              />
                                            </Col>
                                            <Col span={6}>
                                              <Button
                                                style={{ marginRight: "10px" }}
                                              >
                                                Browse...
                                              </Button>
                                              <Button>Google Drive</Button>
                                            </Col>
                                          </Row>
                                          <Row
                                            gutter={30}
                                            style={{ marginTop: "20px" }}
                                          >
                                            <Col span={6}>
                                              Trailer (optional)
                                            </Col>
                                            <Col span={6}></Col>
                                            <Col span={6}>
                                              <Select
                                                style={{ width: "100%" }}
                                                defaultValue="telugu"
                                                disabled
                                                options={[
                                                  {
                                                    value: "telugu",
                                                    label: "Telugu (India)",
                                                  },
                                                  {
                                                    value: "hindi",
                                                    label: "Hindi (India)",
                                                  },
                                                  {
                                                    value: "spanish",
                                                    label: "Spanish (Spain)",
                                                  },
                                                ]}
                                              />
                                            </Col>
                                            <Col span={6}>
                                              <Button
                                                style={{ marginRight: "10px" }}
                                              >
                                                Browse...
                                              </Button>
                                              <Button>Google Drive</Button>
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col span={24}>
                                          <Divider
                                            style={{ margin: "10px 0" }}
                                          />
                                        </Col>
                                        <Col span={24}>
                                          <Button>Add audio file</Button>
                                        </Col>
                                      </Row>

                                      <Row
                                        gutter={30}
                                        style={{ marginTop: "30px" }}
                                      >
                                        <Col span={24}>
                                          <Title level={4}>
                                            Timed Text{" "}
                                            <Tooltip title="Some description text runs here like this">
                                              <span
                                                style={{ fontSize: "15px" }}
                                              >
                                                <InfoCircleOutlined
                                                  size="small"
                                                  color="rgba(0, 0, 0, 0.45)"
                                                />
                                              </span>
                                            </Tooltip>
                                          </Title>
                                        </Col>
                                        <Col span={24}>
                                          <Text
                                            type="warning"
                                            style={{ marginRight: "10px" }}
                                          >
                                            <span>
                                              <WarningFilled />
                                            </span>{" "}
                                            Missing English
                                          </Text>
                                          <Text
                                            type="warning"
                                            style={{ marginRight: "10px" }}
                                          >
                                            <span>
                                              <WarningFilled />
                                            </span>{" "}
                                            Missing English
                                          </Text>
                                        </Col>
                                        <Divider style={{ margin: "7px 0" }} />
                                        <Col span={24}>
                                          No Timed text files have been added
                                        </Col>
                                        <Divider style={{ margin: "7px 0" }} />
                                        <Col span={24}>
                                          <Button>Add timed text</Button>
                                        </Col>
                                      </Row>
                                      <Divider style={{ marginTop: "3%" }} />
                                      <Row
                                        gutter={30}
                                        style={{
                                          marginTop: "2%",
                                          marginBottom: "1%",
                                        }}
                                      >
                                        <Col span={24}>
                                          <Title level={4}>
                                            Stream{" "}
                                            <Tooltip title="Some description text runs here like this">
                                              <span
                                                style={{ fontSize: "15px" }}
                                              >
                                                <InfoCircleOutlined
                                                  size="small"
                                                  color="rgba(0, 0, 0, 0.45)"
                                                />
                                              </span>
                                            </Tooltip>
                                          </Title>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col>
                                          <Form.Item
                                            {...restField}
                                            name={[name, "ep_skipIntroStart"]}
                                            label="Skip Intro Start"
                                          >
                                            <InputNumber
                                              placeholder="Enter start time in seconds"
                                              min={1}
                                              max={18000}
                                            />
                                          </Form.Item>
                                        </Col>
                                        <Col span={1}></Col>
                                        <Col>
                                          <Form.Item
                                            {...restField}
                                            name={[name, "ep_skipIntroEnd"]}
                                            label="Skip Intro End"
                                          >
                                            <InputNumber
                                              placeholder="Enter end time in seconds"
                                              disabled={contentType === "song"}
                                              min={1}
                                              max={18000}
                                            />
                                          </Form.Item>
                                        </Col>
                                      </Row>

                                      <Divider />

                                      <Row justify="end">
                                        <Col span={24}>
                                          <Checkbox
                                            onClick={(e) => {
                                              console.log(
                                                "deleting ep - ",
                                                key + 1,
                                                e.target.checked
                                              );
                                              handleDeleteEpisode(
                                                key + 1,
                                                e.target.checked
                                              );
                                            }}
                                          >
                                            Delete this episode
                                          </Checkbox>
                                        </Col>
                                      </Row>
                                    </Panel>
                                  </Collapse>
                                </>
                              ))}
                              <Form.Item>
                                <Row
                                  justify="end"
                                  style={{ marginTop: "15px" }}
                                >
                                  <Col span={24}>
                                    <Button
                                      onClick={() => add()}
                                      type="primary"
                                      style={{ padding: "0 20px" }}
                                    >
                                      Add episode
                                    </Button>
                                  </Col>
                                </Row>
                              </Form.Item>
                            </>
                          )}
                        </Form.List>
                      </Form>
                    </Col>
                  </Row>
                  <Divider />

                  <Row justify="end">
                    <Col span={24} style={{ textAlign: "right" }}>
                      <Button
                        type="primary"
                        style={{ padding: "0 20px" }}
                        onClick={() => {
                          handleEpisodeSubmit();
                        }}
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="Availability" key="4">
                  {/* <Row style={{ marginTop: '20px' }}>
                    <Col span={24}>
                      <Title level={5}>
                        Where and how can Amazon customers watch this title?{' '}
                        <Tooltip title="Some description text runs here like this">
                          <span style={{ fontSize: '15px' }}>
                            <InfoCircleOutlined
                              size="small"
                              color="rgba(0, 0, 0, 0.45)"
                            />
                          </span>
                        </Tooltip>
                      </Title>
                      <p>
                        <Text>
                          Set where this title can be viewed, offer types, and
                          availability dates.
                        </Text>
                      </p>
                      <p>
                        <Text>
                          Eligible locations are basedon the title's metadata
                          languages and require, audio, or caption file
                          matching each language. Additional requirements are
                          displayed. <a href="#">Learn more</a>
                        </Text>
                      </p>
                      <p>
                        <Text>
                          Note: All audio and timed text files added to this
                          title will be published to all selected territories.
                          You should only distribute localized assets into
                          territories for which you have rights.{' '}
                          <a href="#">Learn more</a>
                        </Text>
                      </p>
                    </Col>
                  </Row> */}
                  {/* Locations Table  */}
                  <Row>
                    <Col span={24}>
                      {/* <Table
                        columns={availableTableColummns}
                        dataSource={availableTableData}
                      /> */}
                      <Form layout="vertical" form={geoAccessForm}>
                        <Form.Item
                          name="listType"
                          label={"Content access"}
                          rules={[{ required: true }]}
                          style={{ marginTop: "2%" }}
                          noStyle
                          initialValue={"allow_all"}
                        >
                          <Radio.Group
                            value={listType}
                            onChange={(e) => setListType(e.target.value)}
                            defaultValue={"allow_all"}
                            style={{ marginTop: "1%" }}
                          >
                            <Radio value="allow_all">Allow Globally</Radio>
                            <Radio value="allow">Allow List</Radio>
                            <Radio value="disallow">Deny List</Radio>
                          </Radio.Group>
                        </Form.Item>

                        {["allow", "disallow"].includes(listType) && (
                          <Form.Item
                            name={`countryMap`}
                            label={"Countries"}
                            rules={[{ required: true }]}
                            style={{ width: "100%", marginTop: "1%" }}
                          >
                            <Select
                              showSearch
                              mode="multiple"
                              placeholder={`Select countries to be ${listType}ed..`}
                              style={{ width: "100%" }}
                            >
                              {Object.entries(countryCodes).map(
                                ([code, name]) => (
                                  <Option key={code} value={code}>
                                    {name}
                                  </Option>
                                )
                              )}
                            </Select>
                          </Form.Item>
                        )}
                      </Form>
                    </Col>
                  </Row>
                  <Divider />
                  {/* Pricing Model Block */}
                  <Row>
                    <Col span={24}>
                      <Text>
                        <strong>
                          Which pricing model do you want to use?{" "}
                        </strong>
                        <Tooltip title="Some description text runs here like this">
                          <span style={{ fontSize: "15px" }}>
                            <InfoCircleOutlined
                              size="small"
                              color="rgba(0, 0, 0, 0.45)"
                            />
                          </span>
                        </Tooltip>
                      </Text>
                    </Col>
                    <Form layout="vertical" form={monetizationStreamingForm}>
                      <Col span={24}>
                        <Form.Item name="model">
                          <Radio.Group
                            style={{ marginTop: "1%" }}
                            onChange={(e) =>
                              setMonetizationModel(e.target.value)
                            }
                          >
                            <Radio value="rent">Rent</Radio>
                            <Radio value="subscription">Subscription</Radio>
                            <Radio value="free">Free</Radio>
                          </Radio.Group>
                        </Form.Item>
                        {monetizationModel === "rent" && (
                          // <>
                          //   <Form.Item
                          //     name="streamPeriod"
                          //     label="Streaming Period"
                          //     className="form-item-selector"
                          //     rules={[{ required: true }]}
                          //   >
                          //     <InputNumber
                          //       min={1}
                          //       max={30}
                          //       placeholder="Enter number of days (1-30)"
                          //     />
                          //   </Form.Item>
                          //   <Form.Item
                          //     name="subscriberPrice"
                          //     label="Price for Subscribers"
                          //     className="form-item-selector"
                          //     rules={[{ required: true }]}
                          //   >
                          //     <MultiCurrencyInput
                          //       form={monetizationStreamingForm}
                          //       fieldName={"subscriberPrice"}
                          //     ></MultiCurrencyInput>
                          //   </Form.Item>
                          //   <Form.Item
                          //     name="nonSubscriberPrice"
                          //     label="Price for Non Subscribers"
                          //     className="form-item-selector"
                          //     rules={[{ required: true }]}
                          //   >
                          //     <MultiCurrencyInput
                          //       form={monetizationStreamingForm}
                          //       fieldName={"nonSubscriberPrice"}
                          //     ></MultiCurrencyInput>
                          //   </Form.Item>
                          // </>
                          <>
                            <Form.List name="currencyMap">
                              {(fields, { add, remove }) => (
                                <>
                                  <Space
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                    }}
                                    align="baseline"
                                  >
                                    <Form.Item
                                      name={"def_currency_1"}
                                      label="Currency"
                                      style={{ width: "100%" }}
                                      className="form-item-selector"
                                    >
                                      <Select
                                        style={{ width: "200px" }}
                                        defaultValue={"INR"}
                                      >
                                        {codes.map((cc) => (
                                          <Select.Option
                                            key={cc}
                                            value={cc}
                                            placeholder={"Select a Currency"}
                                          >
                                            {currencycodes[cc]}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                    <Form.Item name={"def_mrp_1"} label="MRP">
                                      <InputNumber placeholder="Enter amount" />
                                    </Form.Item>
                                  </Space>
                                  <Space
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                      marginTop: -15,
                                    }}
                                    align="baseline"
                                  >
                                    <Form.Item
                                      name={"def_currency_2"}
                                      label="Currency"
                                      style={{ width: "100%" }}
                                      className="form-item-selector"
                                      noStyle
                                    >
                                      <Select
                                        style={{ width: "200px" }}
                                        defaultValue={"USD"}
                                      >
                                        {codes.map((cc) => (
                                          <Select.Option
                                            key={cc}
                                            value={cc}
                                            placeholder={"Select a Currency"}
                                          >
                                            {currencycodes[cc]}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                    <Form.Item
                                      name={"def_mrp_2"}
                                      label="MRP"
                                      noStyle
                                    >
                                      <InputNumber placeholder="Enter amount" />
                                    </Form.Item>
                                  </Space>
                                  {fields.map(({ key, name, ...restField }) => (
                                    <Space
                                      key={key}
                                      style={{
                                        display: "flex",
                                        marginTop: 8,
                                        marginBottom: 8,
                                        width: "100%",
                                      }}
                                      align="baseline"
                                    >
                                      <Form.Item
                                        {...restField}
                                        name={[name, "currency"]}
                                        label="Currency"
                                        style={{
                                          width: "100%",
                                          columnWidth: "40%",
                                        }}
                                        className="form-item-selector"
                                        noStyle
                                      >
                                        <Select
                                          style={{ width: "200px" }}
                                          placeholder={"Select a Currency"}
                                        >
                                          {codes.map((cc) => (
                                            <Select.Option
                                              key={cc}
                                              value={cc}
                                              placeholder={"Select a Currency"}
                                            >
                                              {currencycodes[cc]}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                      <Form.Item
                                        {...restField}
                                        name={[name, "mrp"]}
                                        label="MRP"
                                        noStyle
                                      >
                                        <InputNumber placeholder="Enter amount" />
                                      </Form.Item>
                                      {fields.length > 0 &&
                                        key === fields.length - 1 && (
                                          <>
                                            <PlusCircleOutlined
                                              onClick={() => add()}
                                            />
                                            <MinusCircleOutlined
                                              onClick={() => remove(name)}
                                            />
                                          </>
                                        )}
                                    </Space>
                                  ))}
                                  {fields.length === 0 && (
                                    <Form.Item>
                                      <Button
                                        type="dashed"
                                        onClick={() => add()}
                                        block
                                        icon={<PlusOutlined />}
                                      >
                                        Add currency
                                      </Button>
                                    </Form.Item>
                                  )}
                                </>
                              )}
                            </Form.List>
                          </>
                        )}
                      </Col>
                    </Form>
                  </Row>
                  <Divider />
                  <Row justify="end">
                    <Col span={24} style={{ textAlign: "right" }}>
                      <Button
                        type="primary"
                        style={{ padding: "0 20px" }}
                        onClick={handleSeriesAvailabilitySubmit}
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </Col>
          </Row>
        )}
      </div>

      {/* Standalone Modal */}
      <Modal
        title="Add Title"
        open={showModal}
        onCancel={() => setShowModal(false)}
        onOk={handleStandAloneTitleSubmit}
        okText={"Continue"}
      >
        <Form layout="vertical" form={addStandloneTitleForm}>
          <Form.Item
            label="Title"
            required
            tooltip="Some information about this title displays here"
            name={"title"}
          >
            <Input placeholder="Enter title here..." value="Raja Rani Movie" />
          </Form.Item>

          <Form.Item
            label="Category"
            required
            tooltip="Some information about this title displays here"
            name={"category"}
            initialValue={"movie"}
          >
            <Select
              defaultValue="movie"
              placeholder="Select a Category"
              // onChange={setContentType}
              options={[
                { value: "movie", label: "Movies" },
                { value: "shortfilms", label: "Short Films" },
                { value: "clips", label: "Clips" },
                { value: "concerts", label: "Concerts and Performances" },
                { value: "educational", label: "Educational" },
                { value: "interviews", label: "Interviews" },
                { value: "musicvideos", label: "Music Videos" },
                { value: "reporting", label: "Reporting and Journalism" },
                { value: "sportingevents", label: "Sporting Events" },
              ]}
            />
          </Form.Item>

          <Form.Item
            label="Title metadata language"
            required
            tooltip="Some information about this title displays here"
            name={"metaLanguage"}
            initialValue={"english"}
          >
            <Select
              defaultValue="english"
              options={[
                { value: "english", label: "English" },
                { value: "telugu", label: "Telugu" },
                { value: "hindi", label: "Hindi" },
              ]}
            />
          </Form.Item>
        </Form>
      </Modal>

      {/* Episodes Modal */}
      <Modal
        title="Add Title"
        open={seriesTitleModal}
        onCancel={() => setSeriesTitleModal(false)}
        onOk={handleSeriesTitleSubmit}
        okText="Continue"
      >
        <Form layout="vertical" form={addSeriesTitleForm}>
          <Form.Item
            name={"title"}
            label="Series title"
            required
            tooltip="Some information about this title displays here"
          >
            <Input placeholder="Enter title here..." />
          </Form.Item>
          <Form.Item
            label="Synopsis"
            name="description"
            required
            tooltip="Some information about this title displays here"
          >
            <TextArea rows={3} showCount maxLength={400}></TextArea>
          </Form.Item>

          <Form.Item
            label="Category"
            name="category"
            required
            tooltip="Some information about this title displays here"
            initialValue={"tvshows"}
          >
            <Select
              defaultValue="tvshows"
              options={[
                { value: "tvshows", label: "TV Shows" },
                { value: "shortfilms", label: "Short Films" },
                { value: "clips", label: "Clips" },
                { value: "concerts", label: "Concerts and Performances" },
                { value: "educational", label: "Educational" },
                { value: "interviews", label: "Interviews" },
                { value: "musicvideos", label: "Music Videos" },
                { value: "reporting", label: "Reporting and Journalism" },
                { value: "sportingevents", label: "Sporting Events" },
              ]}
            />
          </Form.Item>

          <Form.Item
            label="Title metadata language"
            required
            tooltip="Some information about this title displays here"
            name="metaLanguage"
            initialValue={"english"}
          >
            <Select
              defaultValue="english"
              options={[
                { value: "english", label: "English" },
                { value: "telugu", label: "Telugu" },
                { value: "hindi", label: "Hindi" },
              ]}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddContent;
